{
  "actividades": {
    "actionActivate": "Activate",
    "actionDeactivate": "Deactivate",
    "actionDelete": "Delete",
    "actionEdit": "Edit",
    "bannerCreated": "Activity created successfully.",
    "bannerDeleted": "Activity deleted.",
    "bannerUpdated": "Activity updated successfully.",
    "buttonCancel": "Cancel",
    "buttonCreate": "Create activity",
    "buttonSave": "Save changes",
    "buttonUpdate": "Update activity",
    "confirmDelete": "Are you sure you want to delete the activity \"{{name}}\"?",
    "currencies": {
      "ARS": "Argentine peso",
      "BRL": "Brazilian real",
      "CAD": "Canadian dollar",
      "CLP": "Chilean peso",
      "COP": "Colombian peso",
      "EUR": "Euro",
      "GBP": "British pound",
      "LOCAL": "Local currency",
      "MXN": "Mexican peso",
      "PEN": "Peruvian sol",
      "USD": "US dollar"
    },
    "empty": "No activities registered.",
    "errorDelete": "Could not delete the activity.",
    "errorLoad": "Error loading activities.",
    "errorMissingCurrency": "Currency is required.",
    "errorMissingName": "Activity name is required.",
    "errorMissingRate": "Hourly rate is required.",
    "errorMissingTenant": "User organization not found (tenant_id/org_id).",
    "errorNameRequired": "Activity name is required.",
    "errorRatePositive": "The hourly cost must be greater than 0.",
    "errorSave": "Could not save the activity.",
    "errorToggle": "Could not change the activity status.",
    "fieldCurrency": "Currency",
    "fieldDescription": "Description",
    "fieldDescriptionPlaceholder": "Brief description of the activity...",
    "fieldHourlyRate": "Hourly rate",
    "fieldHourlyRatePlaceholder": "E.g. 3.50",
    "fieldName": "Name",
    "fieldNamePlaceholder": "E.g. Sowing, Irrigation, Harvest",
    "formTitleEdit": "Edit activity",
    "formTitleNew": "New activity",
    "loading": "Loading activities…",
    "readOnlyNote": "Only the owner and administrators can create or edit activities.",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "tableNoResults": "No activities registered.",
    "tableTitle": "Activity list",
    "thActions": "Actions",
    "thCost": "Cost",
    "thDescription": "Description",
    "thName": "Activity",
    "thStatus": "Status",
    "title": "Activities",
    "subtitle": "Activity catalog with hourly cost.",
    "fieldNameLabel": "Name",
    "fieldHourlyRateLabel": "Hourly cost",
    "fieldCurrencyLabel": "Currency",
    "fieldDescriptionLabel": "Description (optional)",
    "fieldDescriptionOptional": "Description (optional)",
    "perHour": "per hour",
    "errorRateInvalid": "Enter a valid hourly cost."
  },
  "admins": {
    "actions": {
      "makeAdmin": "Make admin",
      "makeOwner": "Make owner",
      "remove": "Remove access"
    },
    "banner": {
      "invitationSent": "Invitation sent successfully.",
      "removed": "Administrator removed from the organization.",
      "roleUpdated": "Role updated."
    },
    "error": {
      "invite": "Could not send the invitation.",
      "load": "Error loading the administrator list.",
      "remove": "Could not remove the administrator.",
      "updateRole": "Could not update the role."
    },
    "form": {
      "buttonInvite": "Send invitation",
      "emailLabel": "Email address",
      "inviteTitle": "Invite new administrator",
      "roleLabel": "Role"
    },
    "subtitle": "Manage your organization's administrators and their roles.",
    "table": {
      "actions": "Actions",
      "email": "Email address",
      "name": "Name",
      "noResults": "No administrators registered.",
      "role": "Role",
      "status": "Status"
    },
    "title": "Administrators"
  },
  "app": {
    "brand": "GeoField GPS",
    "header": {
      "goToPanel": "Go to panel",
      "loggedAs": "Signed in as",
      "login": "Sign in",
      "loginMagic": "Magic link",
      "logout": "Sign out",
      "organizationAriaLabel": "Select organization",
      "organizationLabel": "Organization",
      "organizationNone": "No organization",
      "roleAdmin": "Administrator",
      "roleOwner": "Owner",
      "roleTracker": "Tracker"
    },
    "tabs": {
      "actividades": "Activities",
      "admins": "Administrators",
      "asignaciones": "Assignments",
      "planificacion": "Planning",
      "dashboard": "Cost panel",
      "dashboardCostos": "Cost panel",
      "panelCostos": "Cost panel",
      "geocerca": "Geofence",
      "geocercas": "Geofences",
      "home": "Home",
      "inicio": "Home",
      "invitar_tracker": "Invite tracker",
      "invitarTracker": "Invite tracker",
      "nuevaGeocerca": "New geofence",
      "personal": "Staff",
      "pricing": "Pricing",
      "reportes": "Reports",
      "billing": "Billing",
      "tracker": "Tracker",
      "resources": "Resources",
      "benchmarking": "Benchmarking",
      "incidents": "Incidents"
    },
    "title": "GeoField GPS"
  },
  "onboardingCreateOrg": {
    "title": "Create your organization",
    "body": "Create your company workspace to start supervising your field team.",
    "nameLabel": "Organization name",
    "namePlaceholder": "Example: My Company",
    "submit": "Create my organization",
    "creating": "Creating…",
    "alreadyActive": "You already have an active organization.",
    "loginRequired": "You must sign in.",
    "nameRequired": "Enter your organization name.",
    "createdRedirecting": "Organization created. Redirecting…",
    "limitReached": "You already have an organization. You can switch organizations or contact support to create an additional one.",
    "createFailed": "The organization could not be created."
  },
  "asignaciones": {
    "actions": {
      "activate": "Activar",
      "deactivate": "Desactivar",
      "delete": "Eliminar",
      "edit": "Editar",
      "save": "Save assignment",
      "update": "Update assignment",
      "cancel": "Cancel"
    },
    "banner": {
      "created": "Assignment created successfully.",
      "deleted": "Assignment deleted.",
      "updated": "Assignment updated."
    },
    "error": {
      "delete": "Could not delete the assignment.",
      "endBeforeStart": "The end date/time cannot be earlier than the start date/time.",
      "invalidFrequency": "Frequency must be at least 5 minutes.",
      "invalidPerson": "You must select a valid person.",
      "load": "Error loading assignments.",
      "missingActivity": "You must select an activity.",
      "missingEnd": "You must enter an end date/time.",
      "missingGeofence": "You must select a geofence.",
      "missingPerson": "You must select a person.",
      "missingStart": "You must enter a start date/time.",
      "noActiveOrg": "There is no active organization.",
      "personMissingUserId": "The selected person does not have a user_id. It cannot be linked as a tracker.",
      "save": "Could not save the assignment.",
      "update": "Error updating assignment."
    },
    "filters": {
      "refresh": "Refresh",
      "refreshLoading": "Updating…",
      "status": {
        "activo": "Active",
        "inactivo": "Inactive",
        "todos": "All"
      },
      "statusLabel": "Status",
      "searchPlaceholder": "Search (person/geofence)",
      "statusDefault": "Status: all",
      "statusAll": "Status: all",
      "geofenceAll": "Geofence: all",
      "personalAll": "Personnel: all"
    },
    "fields": {
      "person": "Person",
      "geofence": "Geofence",
      "activity": "Activity",
      "startAt": "Start date/time",
      "endAt": "End date/time",
      "status": "Status",
      "frequencyMinutes": "Frequency (minutes)"
    },
    "statusOptions": {
      "active": "Active"
    },
    "form": {
      "activityLabel": "Activity",
      "activityPlaceholder": "Select an activity",
      "select": "Select",
      "buttonCancel": "Cancel",
      "buttonCreate": "Create assignment",
      "buttonUpdate": "Update assignment",
      "cancelEditButton": "Cancel editing",
      "editTitle": "Edit assignment",
      "endLabel": "End date/time",
      "endOptionalHint": "Optional",
      "frequencyLabel": "Frequency (minutes)",
      "geofenceLabel": "Geofence",
      "geofencePlaceholder": "Select a geofence",
      "newTitle": "New assignment",
      "personLabel": "Person",
      "personPlaceholder": "Select a person",
      "quickActivity": {
        "newButton": "New activity",
        "newNamePlaceholder": "Name of the new activity",
        "noActivitiesHint": "No activities (create one in the Activities module or below).",
        "saveButton": "Save activity",
        "saving": "Saving…"
      },
      "saveButton": "Save assignment",
      "startLabel": "Start date/time",
      "statusActive": "Active",
      "statusInactive": "Inactive",
      "statusLabel": "Status",
      "updateButton": "Update assignment",
      "newActivityPlaceholder": "Name of the new activity",
      "saveActivityButton": "Save activity",
      "savingActivity": "Saving…",
      "cancelButton": "Cancel",
      "startDateLabel": "Start date",
      "startDatePlaceholder": "DD/MM/YYYY HH:MM or 2025-11-13T09:11",
      "endDateLabel": "End date (optional)",
      "endDatePlaceholder": "DD/MM/YYYY HH:MM or 2025-11-14T19:17",
      "activityOptional": "(Optional) Select…",
      "createButtonLabel": "Create assignment"
    },
    "messages": {
      "catalogError": "Error loading catalogs (personnel, geofences, activities).",
      "confirmDelete": "Are you sure you want to delete this assignment?",
      "createGenericError": "Could not create the assignment.",
      "createSuccess": "Assignment created successfully.",
      "deleteError": "Could not delete the assignment.",
      "deleteSuccess": "Assignment deleted successfully.",
      "activatedSuccess": "Assignment activated successfully.",
      "deactivatedSuccess": "Assignment deactivated successfully.",
      "toggleStatusError": "Error changing assignment status.",
      "frequencyInvalidRange": "Frequency must be between 5 minutes and 12 hours.",
      "frequencyTooLow": "The minimum allowed frequency is 5 minutes.",
      "loadError": "Error loading assignments.",
      "loadingData": "Loading assignment data…",
      "noActivities": "No activities created. Create at least one Activity to assign.",
      "noPersonal": "No active personnel in this organization. Reactivate or create at least one person.",
      "overlapError": "This person already has an active assignment that overlaps in that date range.",
      "saveGenericError": "An error occurred while saving the assignment.",
      "selectDates": "You must enter a start and end date and time.",
      "selectPersonAndFence": "You must select a person and a geofence.",
      "updateGenericError": "Could not update the assignment.",
      "updateSuccess": "Assignment updated successfully."
    },
    "table": {
      "actions": "Actions",
      "activity": "Activity",
      "end": "End",
      "frequency": "Freq (min)",
      "geofence": "Geofence",
      "noResults": "No assignments registered.",
      "person": "Person",
      "start": "Start",
      "status": "Status",
      "title": "Assignment list"
    },
    "title": "Assignments",
    "states": {
      "all": "all",
      "active": "active",
      "inactive": "inactive"
    }
  },
  "auth": {
    "backToLogin": "Back to sign in",
    "errorTitle": "Authentication failed",
    "invalidOrExpiredLink": "The link is invalid, has expired, or was already used.",
    "panelTitle": "Operations panel",
    "goDashboard": "Go to dashboard",
    "timeout": "Authentication took too long. Try again.",
    "selection": {
      "title": "Select organization",
      "loading": "Loading organizations linked to your user...",
      "invalidSessionTitle": "Invalid session",
      "invalidSessionBody": "There is no active session. Sign in again.",
      "noOrganizationsBody": "You signed in successfully, but we could not find organizations linked to your user.",
      "noOrganizationsHelp": "Contact the administrator so they can assign you an organization, or create a new one from the admin panel.",
      "subtitle": "You signed in successfully. Now choose the organization you want to work with right now.",
      "noName": "(no name)",
      "code": "Code: {{code}}",
      "noCode": "No code defined"
    },
    "requireOrg": {
      "loading": "Loading your session and current organization...",
      "resolvingOrganization": "Resolving your organization..."
    },
    "callback": {
      "title": "Auth Callback",
      "invalidLinkTitle": "The access link is no longer valid",
      "invalidLinkDetail": "This happens if the link expired or if it was opened or scanned before, for example by an email preview or if it was opened twice.",
      "invalidLinkTipLatest": "Use the most recent email and open it only once.",
      "invalidLinkTipBrowser": "Avoid opening it inside an in-app email browser. If possible, use Open in Chrome.",
      "invalidLinkTipOwner": "If it fails again, ask the Owner to resend the invite.",
      "loginFailedTitle": "Could not complete sign in",
      "loginFailedDetail": "The session could not be established from the callback. This usually happens if the link was consumed, expired, or processed with the wrong client.",
      "loginFailedTipRetry": "Try again with a new link.",
      "loginFailedTipDevice": "Open the link on the same device where you received it.",
      "confirmingSession": "Confirming session...",
      "exchangingCode": "Exchanging code...",
      "restoringSession": "Restoring session...",
      "noSessionFromCallback": "Could not establish session from the callback.",
      "creatingSecureCookies": "Creating secure cookies...",
      "redirecting": "Redirecting..."
    },
    "signup": {
      "title": "Create your free account",
      "subtitle": "Start supervising your field team with GeoField GPS.",
      "labels": {
        "fullName": "Full name (optional)",
        "email": "Email"
      },
      "placeholders": {
        "fullName": "Your name",
        "email": "your@email.com"
      },
      "buttons": {
        "creating": "Sending...",
        "create": "Create free account"
      },
      "errors": {
        "invalidEmail": "Enter a valid email address.",
        "mustAcceptTerms": "You must accept the Terms and Privacy Policy.",
        "sendFailed": "Could not send the Magic Link: {{message}}",
        "unknown": "Unknown error{{#if message}}: {{message}}{{/if}}",
        "googleFailed": "Could not sign in with Google: {{message}}",
        "googleNoUrl": "No redirect URL received from Google.",
        "googleUnknown": "Unknown Google OAuth error{{#if message}}: {{message}}{{/if}}"
      },
      "messages": {
        "magicLinkSent": "We sent you a secure link. Check your email and open it to confirm your account."
      },
      "terms": {
        "acceptance": "I accept the",
        "terms": "Terms",
        "and": "and the",
        "privacy": "Privacy Policy"
      },
      "alreadyHaveAccount": "Already have an account?",
      "loginLink": "Sign in",
      "separator": "or",
      "oauthGoogle": "Sign up with Google"
    }
  },
  "authInvite": {
    "continue": "Continue",
    "expiredOrUsed": "The invitation is invalid, has expired, or was already used.",
    "goToLogin": "Go to sign in",
    "notInviteLink": "This link is not a valid invitation. Use the invitation link you received by email.",
    "processing": "Validating invitation…",
    "timeout": "Invitation validation took too long. Try again.",
    "title": "You have been invited"
  },
  "accountPage": {
    "title": "Account",
    "loading": "Loading account...",
    "noActiveSession": "There is no active session",
    "sessionStatus": "Session status",
    "user": "User",
    "currentOrganization": "Current organization",
    "role": "Role",
    "noSignOutAction": "There is no sign-out action available in the current auth context."
  },
  "errors": {
    "notAuthorized": {
      "title": "Access denied",
      "body": "You do not have permission to access this section. Contact the administrator if you think this is an error."
    }
  },
  "common": {
    "actions": {
      "back": "Back",
      "cancel": "Cancel",
      "close": "Close",
      "delete": "Delete",
      "edit": "Edit",
      "installApp": "Install app",
      "loading": "Loading...",
      "no": "No",
      "logout": "Log out",
      "openApp": "Open app",
      "processing": "Signing out...",
      "retry": "Retry",
      "save": "Save",
      "yes": "Yes"
    },
    "back": "Back",
    "createOrganization": "Create organization",
    "fallbacks": {
      "noAuth": "Not authenticated",
      "noEmail": "No email",
      "noOrg": "No organization"
    },
    "language": {
      "en": "English",
      "es": "Spanish",
      "fr": "French"
    },
    "orgNamePlaceholder": "Organization name (e.g. Farm A)",
    "refreshContext": "Refresh context",
    "roles": {
      "noRole": "NO ROLE",
      "root": "ROOT"
    },
    "select": "Select",
    "sending": "Sending...",
    "show": "Show",
    "hide": "Hide",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "loading": "Loading",
    "search": "Search",
    "noResults": "No results",
    "separator": "—",
    "zoom": "Zoom",
    "refresh": "Refresh",
    "ok": "OK",
    "openArrow": "Open →",
    "debug": "Debug",
    "pagination": {
      "pageOf": "Page {{page}} of {{total}}",
      "prev": "Prev",
      "next": "Next"
    },
    "states": {
      "pending": "Pending",
      "visible": "Visible",
      "hidden": "Hidden"
    }
  },
  "dashboard": {
    "welcome": "Welcome to GeoField GPS",
    "sessionAs": "Signed in as {{role}}",
    "email": "Email",
    "organizationId": "Organization ID",
    "goToDashboard": "Go to dashboard",
    "deleteAccount": "Delete account",
    "managePlan": "Manage plan",
    "subscribePro": "Subscribe to PRO",
    "helpCenter": "Help center",
    "help": {
      "quickGuide": {
        "title": "Quick guide",
        "desc": "Learn how to use the app step by step."
      },
      "faq": {
        "title": "Frequently asked questions",
        "desc": "Answers to the most common questions."
      },
      "support": {
        "title": "Support",
        "desc": "Do you have a problem or question? Contact us."
      },
      "updates": {
        "title": "Updates",
        "desc": "Recent changes, improvements and updates."
      }
    },
    "adminPanel": {
      "title": "Admin Panel",
      "description": "Manage users, roles and organizations from here.",
      "sections": {
        "users": "Users",
        "roles": "Roles",
        "organizations": "Organizations"
      },
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "createdAt": "Created At",
        "description": "Description"
      }
    },
    "adminTools": {
      "title": "Administrator tools",
      "protectedPanel": "Select a module to manage your app. This panel is restricted to users with owner or admin role."
    },
    "administracion": {
      "title": "Administration"
    },
    "adminReportes": {
      "title": "Reports"
    },
    "cards": {
      "totalCost": "Total cost",
      "totalGeofences": "Geofences",
      "totalHours": "Total hours",
      "totalPersons": "Personnel"
    },
    "charts": {
      "costByActivity": "Cost by activity",
      "costByGeofence": "Cost by geofence",
      "costByPerson": "Cost by person",
      "hoursByDay": "Hours by day"
    },
    "errorLoad": "Error loading the cost panel.",
    "filters": {
      "apply": "Apply",
      "clear": "Clear",
      "dateFromLabel": "From",
      "dateToLabel": "To"
    },
    "subtitle": "View aggregated costs by person, activity and geofence.",
    "title": "Cost panel",
    "currentPlan": "Current plan",
    "maxPlanEnterprise": "Your organization already has the maximum plan (Enterprise).",
    "subscribeEnterprise": "Subscribe to Enterprise"
  },
  "dashboardCostos": {
    "title": "Cost panel",
    "subtitle": "Visualize KPIs and cost charts by person, activity and geofence.",
    "currentOrganization": "Current organization",
    "actions": {
      "refresh": "Refresh data",
      "exportData": "Export data",
      "exportGraphic": "Export graphic"
    },
    "kpis": {
      "totalHours": "Total hours",
      "totalCost": "Total cost",
      "registrations": "Registrations",
      "avgRate": "Average rate"
    },
    "errors": {
      "invalidAction": "Invalid action",
      "missingDates": "You must select a date range",
      "invalidDateRange": "The \"From\" date cannot be later than the \"To\" date",
      "load": "Error loading cost panel"
    },
    "loading": "Loading…",
    "chartDimension": "Dimension",
    "chartMetric": "Metric",
    "chartTitle": "Cost chart",
    "chartType": "Chart type",
    "chartTypeArea": "Area",
    "chartTypeBar": "Bar",
    "chartTypeLine": "Line",
    "chartTypePie": "Pie",
    "colActividad": "Activity",
    "colCategoria": "Category",
    "colCosto": "Cost",
    "colFecha": "Date",
    "colGeocerca": "Geofence",
    "colHoras": "Hours",
    "colMoneda": "Currency",
    "colPersona": "Person",
    "colRegistros": "Records",
    "colTarifaPromedio": "Avg. rate",
    "dimensionActividad": "Activity",
    "dimensionFecha": "Date",
    "dimensionGeocerca": "Geofence",
    "dimensionPersona": "Person",
    "filtersActivity": "Activity",
    "filtersAll": "All",
    "filtersApply": "Apply filters",
    "filtersClear": "Clear filters",
    "filtersFrom": "From",
    "filtersGeofence": "Geofence",
    "filtersPerson": "Person",
    "filtersTitle": "Filters",
    "filtersTo": "To",
    "kpiCurrencies": "Currencies",
    "metricCost": "Cost",
    "metricHours": "Hours",
    "metricRecords": "Records",
    "metricAvgRate": "Average rate",
    "tableEmpty": "No data to display",
    "tableNoResults": "No data for the current filters",
    "tableTitle": "Details for selected dimension",
    "chartNoData": "No data available",
    "loadingAuth": "Loading your session and current organization…",
    "noOrgAssigned": "There is no active organization for this user.",
    "noAccess": "You don't have access to this module",
    "currentRole": "Current role",
    "noRole": "no role",
    "loadingPermissions": "Loading permissions…",
    "currenciesSummaryTitle": "Summary by currency",
    "labelHours": "hours",
    "exportNoData": "No data to export",
    "exportChartError": "Could not export chart"
  },
  "forgot": {
    "back": "Back to sign in",
    "email": "Email",
    "emailPh": "your@email.com",
    "errorEmail": "Enter a valid email address.",
    "errorGeneric": "Could not send the email.",
    "noteDesc": "The link will go through /auth/callback and redirect you to /reset-password to create your new password.",
    "noteTitle": "Note",
    "send": "Send link",
    "sending": "Sending…",
    "subtitle": "We'll send you a link to create a new password. If it doesn't arrive, check your spam folder.",
    "success": "✅ If the email exists, you'll receive a link to create a new password. Check your spam folder and open it in the same browser.",
    "tip": "Tip: if the link fails, generate a new one and open it in an incognito window.",
    "title": "Reset password"
  },
  "geocercas": {
    "areaUnitLabel": "Area unit",
    "areaLabel": "Area",
    "buttonClearCanvas": "Clear map",
    "buttonDeleteSelected": "Delete selected",
    "buttonDrawByCoords": "Draw by coordinates",
    "buttonSave": "Save geofence",
    "buttonShowAll": "Show all",
    "buttonShowOnMap": "Show on map",
    "buttonShowSelected": "Show selected",
    "cardListBody": "Soon you will be able to see the list of existing geofences and their details here. For now, use the New geofence option to create and edit.",
    "cardListTitle": "Geofence list",
    "cardNewBody": "Create a new geofence on the map, measure its surface, and assign it to your staff or activities.",
    "cardNewCta": "Go to New geofence →",
    "cardNewTitle": "New geofence",
    "currentOrgLabel": "Current organization:",
    "currentUserLabel": "User:",
    "cursorHint": "Move the mouse over the map",
    "deleteConfirm": "Delete the selected geofences?",
    "deletedCount": "Deleted: {{count}}",
    "draftLabel": "Draft",
    "errorCoordsInvalid": "Invalid coordinates. Use format: lat,lng (one per line).",
    "errorNameRequired": "Enter a name for the geofence.",
    "errorNoGeojson": "GeoJSON for the geofence was not found.",
    "errorNoShape": "Draw a geofence or create one by coordinates before saving.",
    "errorSelectAtLeastOne": "Select at least one geofence.",
    "lat": "Lat",
    "lng": "Lng",
    "loadingDataset": "Loading dataset...",
    "loadingGeofence": "Loading geofence…",
    "modalDraw": "Draw",
    "modalHintRule": "1 point = small square | 2 points = rectangle | 3+ = polygon",
    "modalInstruction": "Format:",
    "modalOnePerLine": "(one per line)",
    "modalTitle": "Draw by coordinates",
    "noGeofences": "You have no geofences yet.",
    "noOrgFallback": "— (no organization selected)",
    "pageSubtitle": "Manage your organization’s geofences. You can create zones on the map, measure their area, and review existing ones.",
    "pageTitle": "Geofences",
    "panelTitle": "Geofences",
    "placeholderName": "Geofence name",
    "pointsLabel": "Pts",
    "savedOk": "Geofence saved successfully.",
    "subtitleNew": "Draw a geofence on the map and assign it to your staff or activities.",
    "titleNew": "New geofence",
    "coordsReady": "Shape created from coordinates.",
    "errorSave": "Could not save the geofence. Try again.",
    "deleteError": "Could not delete. Try again.",
    "errorLoad": "Could not load the geofence.",
    "showManyOk": "Showing {{count}} geofences.",
    "planUsageTitle": "Geofences",
    "planAvailableTitle": "Available",
    "draftYes": "yes",
    "draftNo": "no",
    "create": {
      "defaultName": "Home",
      "nameLabel": "Name",
      "coordsLabel": "Coordinates",
      "coordsHint": "(lat, lng) per line",
      "missingGeometry": "Add coordinates (text \"lat, lng\" per line) or draw a polygon on the map.",
      "polygonFallback": "If the box is left empty, the polygon drawn on the map will be used."
    },
    "errors": {
      "noEditPermission": "You do not have permission to edit.",
      "selectOrganizationFirst": "Select an organization first."
    },
    "plan": {
      "loading": "Loading plan...",
      "error": "Could not load plan limits.",
      "unlimited": "Geofences with no configured limit.",
      "usage": "Current usage: {{used}} / {{max}} geofences",
      "unlimitedShort": "Unlimited",
      "limitReached": "You have reached the geofence limit for your current plan. Upgrade to PRO to continue.",
      "limitReachedTitle": "You have reached your plan's geofence limit.",
      "limitReachedBody": "To create more geofences, upgrade your organization to PRO.",
      "freeHint": "FREE plan active. When you reach the limit, you can upgrade to PRO from here.",
      "activePaidHint": "Your organization has a plan with higher capacity enabled."
    },
    "new": {
      "title": "New geofence",
      "subtitle": "Draw a geofence on the map and assign it to your staff or activities.",
      "placeholderName": "Zone name",
      "buttonDrawByCoords": "Draw by coordinates",
      "buttonCircleByRadius": "Circle by radius",
      "buttonSave": "Save geofence"
    }
  },
  "help": {
    "common": {
      "back": "Back",
      "badge": "Help center",
      "breadcrumb": "Help Center",
      "goHome": "Go to Home",
      "quickGuideBadge": "Quick guide",
      "viewFaq": "View FAQ"
    },
    "faq": {
      "breadcrumb": "Help Center / Frequently asked questions",
      "title": "Frequently asked questions",
      "subtitle": "Quick answers to the most common questions.",
      "goHome": "Go to Home",
      "items": [
        {
          "q": "How do I invite a tracker?",
          "a": "Go to Invite tracker, enter the email address, and send the invitation."
        },
        {
          "q": "How do I activate a tracker with a pairing code?",
          "a": "The administrator selects the person in Invite tracker, generates a code, and copies it. The tracker must sign in with Magic Link, open /tracker-accept, paste the code, and press Activate tracking with code. The code does not replace identity: it only links the organization, person, and authenticated tracker."
        },
        {
          "q": "Can I measure areas with the app?",
          "a": "Yes. When you create or edit a geofence, the app calculates the polygon area and can show it in units such as m², hectares, or acres, depending on the selected unit."
        },
        {
          "q": "What happens if the link expired?",
          "a": "Request a new invitation from the organization."
        }
      ],
      "backToPanel": "Go to panel",
      "sections": [
        {
          "title": "Access and roles",
          "items": [
            {
              "q": "How do I get access to the app?",
              "a": "You need an invitation from an Owner/Admin of an organization. If you don't have access, ask them to invite you."
            },
            {
              "q": "What is the difference between Owner, Administrator and Tracker?",
              "a": "Owner manages the organization and administrators. Administrator manages operational data (geofences, personnel, activities, assignments). Tracker is a field user who sends GPS points."
            },
            {
              "q": "Can I manage more than one organization?",
              "a": "Yes. Owners can work with multiple organizations and switch using the organization selector."
            }
          ]
        },
        {
          "title": "Tracking",
          "items": [
            {
              "q": "Why do I see \"No recent data\" in Tracker?",
              "a": "The tracker may be offline, without location permissions, or without an active assignment. Check permissions and assignments."
            },
            {
              "q": "How often is the location sent?",
              "a": "The frequency is defined in the assignment. The minimum allowed is 5 minutes to preserve battery and data."
            },
            {
              "q": "Does it work with a weak signal?",
              "a": "Yes. The tracker can store points and sync when connectivity returns (depending on your build and permissions)."
            }
          ]
        },
        {
          "title": "Costs and reports",
          "items": [
            {
              "q": "How are costs calculated?",
              "a": "Costs are calculated from assignments (hours) and the hourly rate configured in each activity."
            },
            {
              "q": "Can I export to Excel?",
              "a": "Yes. Reports can be exported as CSV, which you can open in Excel or Google Sheets."
            },
            {
              "q": "Can I filter by geofence, person, activity and date range?",
              "a": "Yes. Use the filters in Reports and the Cost panel to focus by geofence(s), person(s), activity(ies) and dates."
            }
          ]
        },
        {
          "title": "Data and privacy",
          "items": [
            {
              "q": "What location data is stored?",
              "a": "Only the points needed for tracking and geofence validation. Access is controlled by roles and organization."
            },
            {
              "q": "Can a tracker see data from other organizations?",
              "a": "No. Data is isolated by organization (multi-tenant) and protected by database security rules."
            }
          ]
        }
      ],
      "seeQuickGuide": "See quick guide"
    },
    "instructions": {
      "badge": "Quick guide",
      "bestPractice1Body": "Always use the same phone to avoid breaks in tracking.",
      "bestPractice1Title": "Use your main phone",
      "bestPractice2Body": "Keep enough battery or plug in during long shifts.",
      "bestPractice2Title": "Watch your battery",
      "bestPractice3Body": "Do not sign out or disable location while you are on route.",
      "bestPractice3Title": "Keep the session active",
      "bestPractice4Body": "If something does not load, re-open your most recent invitation link.",
      "bestPractice4Title": "Re-open the link if it fails",
      "goToSteps": "Go to steps",
      "recommendationBody": "Before leaving, make sure you see the \"Active tracking\" status on your screen.",
      "recommendationTitle": "Recommendation",
      "resultBullets": [
        "Your invitation was accepted successfully.",
        "You granted location permissions on your phone.",
        "You see the \"Active tracking\" status.",
        "You keep internet and location enabled.",
        "If it does not work, you can request a new invitation or contact support."
      ],
      "resultIntro": "When done, you should have everything ready to share your location without issues:",
      "resultTitle": "What you must confirm",
      "steps": {
        "title": "Step by step",
        "subtitle": "Follow this simple sequence to activate the tracker in a few minutes.",
        "items": [
          {
            "title": "Receive your invitation",
            "items": [
              "You will receive a link by email or message from your organization."
            ]
          },
          {
            "title": "Activate with a code if your administrator gave you one",
            "items": [
              "Sign in with Magic Link.",
              "Open /tracker-accept, paste the code, and press Activate tracking with code."
            ]
          },
          {
            "title": "Open the link on your phone",
            "items": [
              "Open it on the same phone you will use for the tracker."
            ]
          }
        ]
      },
      "subtitle": "Activate your tracker with simple steps and clear messages, with no technical setup.",
      "tipsTitle": "Best practices",
      "title": "Tracker quick guide",
      "toc": {
        "title": "Table of contents",
        "subtitle": "Use these shortcuts to move faster.",
        "items": [
          "Steps",
          "Best practices",
          "Operational modules",
          "Expected result",
          "Recommendation"
        ]
      },
      "viewFaq": "View FAQ",
      "viewResult": "View result",
      "moduleCards": {
        "title": "Operational modules",
        "subtitle": "Use these cards to open planning and efficiency analysis modules quickly.",
        "items": [
          {
            "badge": "PLANNING",
            "title": "Planning",
            "body": "Organize work by geofence, person, activity and period. Review status, progress, dates and planned costs to coordinate field operations.",
            "highlights": [
              "Create and review assignments by period.",
              "Coordinate activities before work execution.",
              "Use real data from the active organization."
            ],
            "cta": "Open Planning",
            "path": "/planificacion"
          },
          {
            "badge": "BENCHMARKING",
            "title": "Benchmarking",
            "body": "Compare efficiency across geofences, people, activities or assignments using hours/m², $/m² and auxiliary metrics per ha or km².",
            "highlights": [
              "Identify best and worst efficiency cases.",
              "Review traffic-light alerts and improvement opportunities.",
              "Export results to CSV for external analysis."
            ],
            "cta": "Open Benchmarking",
            "path": "/benchmarking"
          }
        ]
      }
    },
    "reportsGuide": {
      "badge": "Reports guide",
      "breadcrumb": "Help Center / Reports",
      "title": "Reports guide",
      "subtitle": "Review data, filter results, and export the analysis you need to make faster decisions.",
      "goHome": "Go to Home",
      "goToFilters": "Go to filters",
      "openReports": "Open reports",
      "overviewTitle": "What can you review in Reports?",
      "overviewBody": "Use this view to understand performance by geofence, person, activity and time period, with a summary that is ready for operational decisions.",
      "summaryTitle": "Expected outcome",
      "summaryBody": "When you finish, you should have the right view of performance and be ready to export the data for sharing.",
      "resultTitle": "What to check",
      "summaryBullets": [
        "The date range matches the period you want to review.",
        "The filters for geofence, person, and activity match the operation being analyzed.",
        "The KPIs show the trend and highlight risk or improvement areas.",
        "You can export the data to CSV when you need to share the analysis."
      ],
      "toc": {
        "title": "Table of contents",
        "subtitle": "Use these shortcuts to move faster.",
        "items": [
          "Overview",
          "Filters",
          "Export",
          "Interpretation",
          "Best practices"
        ]
      },
      "cards": [
        {
          "tag": "KPI",
          "title": "Total hours",
          "body": "Review the actual workload by period and compare operations between days, people, or geofences."
        },
        {
          "tag": "COST",
          "title": "Total cost",
          "body": "Analyze the economic impact of the work completed and identify activities with the highest spending."
        },
        {
          "tag": "ASSIGNMENTS",
          "title": "Activity trend",
          "body": "See how each activity changes over time so you can prioritize the right actions."
        }
      ],
      "sections": {
        "title": "How to use reports",
        "items": [
          {
            "title": "Set the time range",
            "body": "Choose the from and to dates to focus the analysis on the correct operating period before relying on the results.",
            "bullets": [
              "Use days, weeks or months depending on the decision to be made.",
              "Verify that the range includes all relevant work."
            ]
          },
          {
            "title": "Apply context filters",
            "body": "Restrict the view by geofence, person, and activity to isolate problems or compare real executions.",
            "bullets": [
              "Combine filters to review a specific detail or a broader view.",
              "Clear the filters when you want to return to the general view."
            ]
          },
          {
            "title": "Read the indicators",
            "body": "Look for changes in hours, cost, and ratios to identify efficiency gaps or opportunities for improvement.",
            "bullets": [
              "Compare the same period against previous trends.",
              "Review the highest and lowest values before taking action."
            ]
          },
          {
            "title": "Export when you need to share",
            "body": "If the analysis needs to go by email, Excel or to an operations committee, export the filtered table.",
            "bullets": [
              "Use CSV to open the file in Excel, Google Sheets or analysis tools.",
              "Create a segment-based export when the query is very specific."
            ]
          }
        ]
      },
      "exportTitle": "Export and analysis",
      "exportPrimaryTitle": "Download for external work",
      "exportPrimaryBody": "The export lets you open the results in Excel or Google Sheets to share them with supervision, finance, or coordination teams.",
      "exportSecondaryTitle": "Use the view as a diagnosis",
      "exportSecondaryBody": "Combining filters and KPIs helps you confirm whether execution is within plan or whether the operation requires corrections.",
      "tips": {
        "title": "Best practices",
        "items": [
          {
            "title": "Keep the range clear",
            "body": "A range that is too wide can hide short-term changes; a very narrow range can be too detailed to decide well."
          },
          {
            "title": "Filter to the real case",
            "body": "If you want to compare two teams or zones, limit the analysis to those segments to avoid noise."
          },
          {
            "title": "Use the export as evidence",
            "body": "When you need to present results, export the clean data and share the context of the reviewed period."
          },
          {
            "title": "Review the trend",
            "body": "Do not focus only on the day value; compare the series to detect sustained changes."
          }
        ]
      }
    },
    "support": {
      "breadcrumb": "Help Center / Support",
      "calendlyLabel": "Calendly",
      "title": "Support",
      "subtitle": "Contact us for technical support, billing questions, or training.",
      "goHome": "Go to Home",
      "emailLabel": "Support email",
      "whatsappLabel": "WhatsApp",
      "viewFaq": "View FAQ",
      "faqLink": "Frequently asked questions",
      "notConfigured": "Support contact is not configured yet.",
      "commonProblems": {
        "title": "Common problems",
        "subtitle": "If something is not working, review these quick solutions before contacting support.",
        "items": [
          {
            "title": "I can’t accept the invitation",
            "desc": "Open the most recent link you received. If it expired or shows an error, ask for a new invitation."
          },
          {
            "title": "The pairing code does not work",
            "desc": "Make sure you first sign in with Magic Link in the same browser or phone. Then paste the most recent code in /tracker-accept. If you see that the user is already linked to another person, the administrator must generate the code for the correct person or use another tracker email."
          },
          {
            "title": "The link does not work",
            "desc": "Copy it completely into your phone browser or open it directly from the original message."
          }
        ]
      }
    },
    "onboarding": {
      "title": "First steps",
      "subtitle": "How to start using the tracker for the first time.",
      "orgCreationLimitReached": "You already have an organization. You can switch organizations or contact support to create an additional one.",
      "orgCreateFailed": "The organization could not be created.",
      "sections": [
        {
          "title": "Invitation and access",
          "items": [
            {
              "q": "How do I start using the tracker?",
              "a": "You will receive an invitation link. Just open it from your phone and follow the steps."
            },
            {
              "q": "Do I need to install anything?",
              "a": "No. Just open the link and accept the permissions when prompted."
            }
          ]
        }
      ]
    },
    "tracker": {
      "title": "Location tracking",
      "subtitle": "What it means for tracking to be active.",
      "sections": [
        {
          "title": "Tracking status",
          "items": [
            {
              "q": "What does 'Active tracking' mean?",
              "a": "It means your location is being shared correctly."
            },
            {
              "q": "Do I need to keep the app open?",
              "a": "Not always. As long as your device has permissions and connection, tracking can continue."
            }
          ]
        }
      ]
    },
    "troubleshooting": {
      "title": "Common problems",
      "subtitle": "Quick solutions for the most common cases.",
      "sections": [
        {
          "title": "Invitation and permissions",
          "items": [
            {
              "q": "I can't accept the invitation",
              "a": "Make sure you open the most recent link. If it keeps failing, request a new invitation."
            },
            {
              "q": "The link says it is inactive",
              "a": "This can happen if you opened an earlier link. Use the latest link received."
            },
            {
              "q": "Tracking is not starting",
              "a": "Check that you accepted location permissions on your device."
            }
          ]
        }
      ]
    },
    "geofences": {
      "title": "Geofences",
      "subtitle": "What they are and how they work within tracking.",
      "sections": [
        {
          "title": "Basic concepts",
          "items": [
            {
              "q": "What is a geofence?",
              "a": "It is an area defined on the map to record entries, exits or presence."
            },
            {
              "q": "Can I measure areas with the app?",
              "a": "Yes. When you create or edit a geofence, the app calculates the polygon area and can show it in units such as m², hectares, or acres, depending on the selected unit."
            },
            {
              "q": "Do I have to do anything as a tracker?",
              "a": "No. The system automatically records your activity when applicable."
            }
          ]
        }
      ]
    },
    "account": {
      "title": "Account and access",
      "subtitle": "Questions about signing in and accessing the organization.",
      "sections": [
        {
          "title": "Access",
          "items": [
            {
              "q": "How do I sign in?",
              "a": "Use your email and password from the sign-in screen."
            },
            {
              "q": "What do I do if I am in the wrong organization?",
              "a": "Make sure you use the correct invitation link or sign in again with the indicated account."
            }
          ]
        }
      ]
    },
    "changelog": {
      "breadcrumb": "Help Center / Changelog",
      "back": "Back",
      "title": "Changelog",
      "subtitle": "Recent improvements and application updates.",
      "goHome": "Go to Home",
      "releases": [
        {
          "version": "v1.2.0 · 2026-04",
          "items": [
            "Improved tracker invitation flow",
            "More stable and reliable tracking",
            "Clearer and more consistent interface",
            "Bug fixes for tracking activation"
          ]
        },
        {
          "version": "v1.1.0 · 2026-03",
          "items": [
            "Improved geofence system",
            "Performance optimization",
            "Login and session handling improvements"
          ]
        }
      ],
      "items": [
        {
          "version": "v1.2.0",
          "date": "2026-04",
          "changes": [
            "Improved tracker invitation flow",
            "More stable and reliable tracking",
            "Clearer and more consistent interface",
            "Bug fixes for tracking activation"
          ]
        },
        {
          "version": "v1.1.0",
          "date": "2026-03",
          "changes": [
            "Improved geofence system",
            "Performance optimization",
            "Login and session handling improvements"
          ]
        }
      ]
    }
  },
  "home": {
    "loadingPermissions": "Loading permissions...",
    "startBadge": "Home",
    "loginToContinue": "Sign in to continue.",
    "goToLogin": "Go to sign in",
    "quickStart": "Quick start",
    "accountStatusBadge": "Account status",
    "missingContextTitle": "Account created successfully",
    "missingContextBody": "Your account already exists, but it is not linked to an organization yet.",
    "trackerWaitingTitle": "If you are a tracker",
    "trackerWaitingStep1": "Tell the administrator that you already created your account.",
    "trackerWaitingStep2": "Wait for the invitation link.",
    "trackerWaitingStep3": "Open the link from this same phone.",
    "trackerWaitingStep4": "After that, you will be able to use GPS tracking.",
    "installTrackerAppCta": "Install app for GPS tracking",
    "pendingInvitation": "Pending invitation",
    "pending": "Pending",
    "retry": "Check again",
    "previewEnvironment": "You are reviewing a Preview deployment.",
    "quickActions": "Quick actions",
    "manageWorkspace": "Manage your workspace",
    "manageWorkspaceDesc": "Access the main panel, review your plan, or manage your account from one place.",
    "subscriptionSummary": "Plan summary",
    "helpCenterTitle": "Help and learning",
    "helpCenterDesc": "Find quick guides, FAQs, support, and product updates.",
    "quickGuideCards": "Help Center",
    "goDashboard": "Go to dashboard",
    "deleteAccount": "Delete account",
    "help": {
      "title": "Help center",
      "quick": "Quick guide",
      "quickDesc": "Learn how to use the app step by step.",
      "faq": "Frequently asked questions",
      "faqDesc": "Answers to the most common questions.",
      "support": "Support",
      "supportDesc": "Do you have a problem or question? Contact us.",
      "news": "Updates",
      "newsDesc": "Recent changes, improvements and updates."
    }
  },
  "deleteAccount": {
    "title": "Delete account",
    "subtitle": "Request permanent deletion of your GeoField GPS account and associated data.",
    "warning": {
      "title": "Warning",
      "body": "Deleting your account is permanent and cannot be undone."
    },
    "whatWillBeDeleted": {
      "title": "What will be deleted",
      "items": {
        "accountInfo": "User account information",
        "profileData": "Personal profile data",
        "trackerAssignments": "Tracker assignments",
        "gpsRecords": "GPS location records",
        "geofences": "Geofences created by the account",
        "activityLogs": "Activity logs related to the account"
      }
    },
    "retention": {
      "title": "Retention note",
      "body": "Some limited data may be temporarily retained when necessary for legal compliance, fraud prevention, or security reasons."
    },
    "processingTime": {
      "title": "Processing time",
      "body": "Account deletion requests are processed within 30 days of receipt. Once completed, the account and associated data cannot be recovered."
    },
    "account": {
      "title": "Account",
      "signedInAs": "Signed in as:",
      "unknownUser": "Unknown user"
    },
    "confirmCheckbox": "I understand this action is permanent and my account data cannot be recovered.",
    "confirmInputLabel": "Type DELETE to confirm",
    "confirmKeyword": "DELETE",
    "submitButton": "Request account deletion",
    "submitting": "Sending...",
    "successMessage": "Your deletion request was received. Your account and associated data will be deleted within the next 30 days.",
    "publicPolicyLink": "View public deletion policy",
    "errors": {
      "noAuthenticatedUser": "No active authenticated user found.",
      "confirmationRequired": "Confirm the action and type \"DELETE\" to continue.",
      "requestFailed": "Could not create the deletion request."
    }
  },
  "inicio": {
    "cards": {
      "common": {
        "soon": "Coming soon"
      },
      "faq": {
        "badge": "Help",
        "body": "Find answers to common questions about invitations, roles, costs and tracker usage.",
        "cta": "View frequently asked questions",
        "title": "Frequently asked questions"
      },
      "instrucciones": {
        "badge": "Quick guide",
        "body": "Follow step by step how to set up organizations, geofences, personnel, activities and trackers.",
        "cta": "View instructions",
        "title": "Instructions"
      },
      "novedades": {
        "badge": "Updates",
        "body": "Review the history of changes, new features, improvements and fixes on the platform.",
        "cta": "View changelog",
        "title": "Updates / Changelog"
      },
      "queEs": {
        "badge": "Information",
        "body": "Learn about the vision, use cases and benefits of GeoField GPS for your organization.",
        "cta": "Read more",
        "title": "What is GeoField GPS?"
      },
      "soporte": {
        "badge": "Support",
        "body": "Need help? Contact us for technical support, billing or questions about your account.",
        "cta": "Go to support",
        "title": "Contact / Support"
      },
      "videoDemo": {
        "badge": "Video",
        "body": "Watch a short demo of how GeoField GPS works in real life.",
        "cta": "View video demo",
        "title": "Video demo"
      }
    },
    "header": {
      "badge": "Help center and resources",
      "subtitle": "From here you can access instructions, frequently asked questions, support and GeoField GPS updates.",
      "title": "Welcome to your panel"
    },
    "onboarding": {
      "badge": "Initial setup",
      "title": "Get started in 5 steps",
      "stepGeocercas": "1. Geofences",
      "stepPersonal": "2. Personnel",
      "stepActividades": "3. Activities",
      "stepAsignaciones": "4. Assignments",
      "stepInvitarTracker": "5. Invite tracker"
    },
    "userInfo": {
      "connectedAs": "Connected as",
      "inOrg": "in the organization",
      "orgIdLabel": "Organization ID:",
      "userLabel": "User:",
      "withRole": "with the role"
    },
    "billing": {
      "managePlan": "Manage plan",
      "managePlanBody": "You can go to the Billing page to view and manage your subscription.",
      "goToBilling": "Go to Billing",
      "previewNote": ""
    }
  },
  "inviteTracker": {
    "backToTracker": "Back to Tracker",
    "emailLabel": "Tracker email address",
    "emailPlaceholder": "tracker@example.com",
    "errors": {
      "emailInvalid": "Enter a valid email address.",
      "emailRequired": "You must enter an email address.",
      "noOrg": "Could not resolve an active organization for this user.",
      "planBlocked": "The organization's current plan does not allow tracker invitations.",
      "planLoadFailed": "Could not load the plan information for this organization.",
      "trackerCountFailed": "Could not check the available tracker quota.",
      "notInOrg": "Your user is not linked to the active organization.",
      "inviteErrorPrefix": "Error sending the invitation"
    },
    "form": {
      "buttonSend": "Send invitation",
      "buttonSending": "Sending invitation…",
      "emailHelp": "An invitation will be sent to this email.",
      "emailLabel": "Tracker email address",
      "emailPlaceholder": "tracker@example.com",
      "selectHelp": "If you select a person, their email will be filled in automatically.",
      "selectLabel": "Select active personnel (optional)",
      "selectPlaceholder": "-- Select personnel --"
    },
    "diag": {
      "orgUsed": "Organization used",
      "user": "User",
      "membersLoaded": "Members loaded"
    },
    "empty": {
      "noMembers": "No active personnel available to invite."
    },
    "ok": {
      "generated": "Invitation generated successfully.",
      "emailSent": "Invitation email sent successfully.",
      "fallbackLink": "Could not send the email. Use this link to share access manually.",
      "magicLinkFallback": "Magic link generated as a fallback."
    },
    "plan": {
      "validating": "Validating organization plan…",
      "validationError": "Could not validate the organization plan.",
      "permissionDisabledTitle": "Invitation permission is not enabled",
      "permissionDisabledBody": "This organization cannot invite trackers right now.",
      "detectedPlan": "Detected plan"
    },
    "messages": {
      "createdWithoutEmail": "Tracker access was created without sending an email.",
      "genericProcessed": "The invitation for {{correo}} was processed successfully.",
      "invited": "An invitation has been sent to {{correo}} to join as a tracker in {{orgName}}.",
      "linkOnlyNoLink": "The invitation was created, but no public link was received.",
      "linkOnlyWithLink": "The invitation was created. Use this link to share access: {{link}}.",
      "magiclinkSent": "A magic access link was sent to {{correo}}.",
      "notOk": "Could not complete the invitation. Check the email and try again.",
      "serverProblem": "There was a problem contacting the invitation server.",
      "unexpectedError": "Unexpected error processing the invitation."
    },
    "onlyExistingNote": "Only people already in your organization can be invited.",
    "orgFallback": "your organization",
    "selectPersonLabel": "Select a person",
    "sendInvite": "Send invitation",
    "subtitle": "Select a member of your personnel or enter an email manually to invite them as a tracker in {{orgName}}.",
    "title": "Invite tracker"
  },
  "landing": {
    "accessBody": "This application requires an account invited by an administrator. If you don't have access, request an invitation from your organization.",
    "accessHint": "Tip: use \"Magic link\" if your administrator invited you by email.",
    "accessTitle": "Access with authorized account",
    "assistanceControlBody": "Verify who was inside each geofence, at what time and in what activity.",
    "assistanceControlTitle": "Attendance control",
    "brandName": "GeoField GPS",
    "brandTagline": "Personnel control with geofences",
    "bulletCostsBody": "Consult Power BI-style panels with costs by person, activity and geofence.",
    "bulletCostsTitle": "Costs",
    "bulletGeocercasBody": "Create geofences for fields, farms, plants, or service points and measure surfaces in m², hectares, or acres.",
    "bulletGeocercasTitle": "Geofences",
    "bulletPersonalBody": "Register your personnel and assign them to activities and specific areas.",
    "bulletPersonalTitle": "Personnel",
    "ctaLogin": "Go to control panel",
    "ctaMagic": "Sign in with magic link",
    "ctaPricing": "View pricing",
    "ctaStart": "Create free account",
    "email": "Email",
    "footerFaq": "Frequently asked questions",
    "footerPrivacy": "Privacy",
    "footerSupport": "Support",
    "footerTerms": "Terms",
    "goPanel": "Go to panel",
    "goToDashboard": "Go to panel",
    "heroBadge": "Smart field control",
    "heroSubtitle": "Verify which locations they visited, how long they stayed, and what activities they completed—all from one dashboard.",
    "heroTitle": "See where your field team works",
    "heroTitleHighlight": "smart geofences",
    "heroTitlePrefix": "Manage your team with",
    "heroTitleSuffix": "anywhere in the world",
    "invalidEmail": "Invalid email.",
    "livePanelLabel": "Live panel",
    "livePanelTitle": "Real-time operations",
    "demoLiveLabel": "Live demo",
    "demoOperationsAreaLabel": "Operations area",
    "demoLoop10sLabel": "Loop 10s",
    "loginTitle": "Sign in",
    "magicLoginCta": "Sign in with magic link",
    "noAccount": "Don’t have an account?",
    "createAccount": "Create account",
    "hasPassword": "Already have a password?",
    "passwordLogin": "Sign in with password",
    "login": "Sign in",
    "loginButton": "Enter",
    "logout": "Sign out",
    "magicEnter": "Sign in with magic link",
    "magicLinkError": "Could not send the link. Please try again.",
    "magicLinkSent": "We sent you an access link. Check your email.",
    "magicNote": "Important: access works only with the real magic link.",
    "multiOrgBody": "Manage multiple companies or projects from a single account, with separate roles and permissions.",
    "multiOrgTitle": "Multi-organization",
    "privacyMiniNote": "Privacy: location is used only for geofence and tracking features as permitted by the user.",
    "quickAccessDesc": "If you prefer, you can sign in using a magic link (no password).",
    "quickAccessTitle": "Quick access",
    "reviewNote": "Note: If you are reviewing the app (Google Play), use the credentials provided in Play Console (App access).",
    "rightsReserved": "All rights reserved",
    "sending": "Sending...",
    "sendMagic": "Send magic link",
    "statusOnline": "Sistema en línea",
    "support": "Support",
    "zonesActive": "Active zones",
    "feature1Title": "Personnel monitoring",
    "feature1Body": "See who is on route, who arrived and who left an operational area.",
    "feature2Title": "Zone control",
    "feature2Body": "Define geofences for offices, routes, clients, or sensitive areas, measure their surface, and get immediate visual context.",
    "feature3Title": "Entry and exit events",
    "feature3Body": "Turn GPS positions into easy-to-review events for operations, auditing and tracking.",
    "feature4Title": "Ready for field teams",
    "feature4Body": "Use it in commercial, technical, logistics or territorial supervision operations.",
    "useCase1Title": "Private security",
    "useCase1Body": "Monitor guard rounds, entries to restricted areas and shift supervision.",
    "useCase2Title": "Commercial teams",
    "useCase2Body": "Verify customer visits, territorial coverage and sales activity.",
    "useCase3Title": "Technical operations",
    "useCase3Body": "Supervise field technicians and validate entry and exit in work zones.",
    "useCase4Title": "Urban logistics",
    "useCase4Body": "Monitor movements within operational zones and detect events automatically."
  },
  "login": {
    "advancedOptions": "Advanced options",
    "back": "Back",
    "badge": "(login-V31 NO-JS)",
    "debug": {
      "lang": "LANG DEBUG",
      "i18n": "I18N DEBUG",
      "supabase": "Supabase"
    },
    "email": "Email",
    "emailLabel": "Email",
    "emailPlaceholder": "your.email@example.com",
    "errorInvalidCredentials": "Invalid credentials.",
    "errorMagicLink": "Could not send the magic link.",
    "errorMagicLinkUnexpected": "Unexpected error sending the magic link.",
    "errorMissingCredentials": "Missing email or password.",
    "errorMissingEmail": "You must enter an email.",
    "errorResetPassword": "Could not send the recovery email.",
    "errorResetPasswordUnexpected": "Unexpected error sending the recovery email.",
    "errors": {
      "bootstrapFailed": "Bootstrap failed (HTTP {{status}}). {{details}}",
      "invalidEmail": "Enter a valid email address.",
      "unknown": "An error occurred while signing in."
    },
    "errorUnexpected": "Unexpected error while signing in.",
    "forgotPassword": "Forgot your password?",
    "forgotPasswordAlt": "Prefer to reset your password? (send email)",
    "goToDashboard": "Go to dashboard",
    "goToNext": "Go to",
    "hidePassword": "Hide password",
    "info": "Stable WebView/TWA login: native submit (no JS events), anti rate-limit by design.",
    "infoMagicLinkSent": "We sent a magic link to your email.",
    "infoResetPasswordSent": "We sent you an email to reset your password. Check your inbox.",
    "hints": {
      "useResetPassword": " — If you never created a password in this environment, use \"{{resetTitle}}\" to create it and then sign in with password."
    },
    "loadingSession": "Loading your session...",
    "magicButton": "Send magic link",
    "magicDescription": "We'll send a secure link to your email so you can sign in without a password.",
    "magicLinkButton": "Send magic link",
    "magicLinkDescription": "We'll send a secure link to your email to sign in without a password.",
    "magicLinkSent": "We sent a magic link to your email.",
    "magicLinkTitle": "Sign in with magic link",
    "magicSubmitting": "Sending link...",
    "modeDesc": "If sign-in succeeds, the server redirects to /auth/callback with tokens.",
    "modeMagic": "Magic link",
    "modePassword": "Password",
    "modeReset": "Reset",
    "modeTitle": "Mode: NO-JS (native form submit)",
    "nextHint": "Useful for tests in PREVIEW. In production you normally do not change it.",
    "nextSuffix": "(next)",
    "password": "Password",
    "passwordLabel": "Password",
    "passwordLoginButton": "Sign in with password",
    "passwordPlaceholder": "Enter your password",
    "passwordTip": "Tip: in Preview and Production the password is different (different Supabase).",
    "previewBadge": "PREVIEW",
    "sessionActive": "You already have an active session.",
    "sessionStarted": "✅ Session started. Entering...",
    "showPassword": "Show password",
    "submit": "Sign in",
    "submitting": "Signing in...",
    "subtitle": "Access your GeoField GPS account",
    "title": "Sign in",
    "userNotAuthorized": "This email is not authorized. Request an invite from the administrator."
  },
  "orgs": {
    "title": "Organizations",
    "myTitle": "My Organizations",
    "createNew": "Create new organization",
    "newTitle": "New organization",
    "form": {
      "name": "Name",
      "slugOptional": "Slug (optional)",
      "namePlaceholder": "E.g. Main Farm",
      "slugPlaceholder": "e.g. main-farm",
      "create": "Create"
    }
  },
  "planning": {
    "header": {
      "badge": "Operational management control",
      "title": "Operational Planning",
      "subtitle": "Plan work by geofence, compare actual execution against the operating budget, and detect deviations with traffic lights, filters, and management export."
    },
    "badges": {
      "localDemo": "Local demo data",
      "organizationData": "Data for the selected organization"
    },
    "periods": {
      "week": "Week",
      "month": "Month",
      "quarter": "Quarter",
      "semester": "Semester",
      "year": "Year",
      "custom": "Custom range"
    },
    "periodSelector": {
      "title": "Analysis period",
      "from": "From",
      "to": "To"
    },
    "filters": {
      "title": "Management filters Plan vs Actual",
      "subtitle": "Focus the review by deviations, geofence, activity, status, or period. The filtered view feeds KPIs, table, Gantt, and CSV.",
      "trafficLight": "Traffic light",
      "geofence": "Geofence",
      "activity": "Activity",
      "status": "Status",
      "dateFrom": "Date from",
      "dateTo": "Date to",
      "all": "All",
      "allFeminine": "All",
      "showing": "Showing {{filtered}} of {{total}} planning records in the current view. KPIs, table, Gantt, and export use this same filter."
    },
    "actions": {
      "exportCsv": "Export executive CSV",
      "exportEmptyHint": "Export becomes available when the filtered view contains planning records.",
      "clearFilters": "Clear filters",
      "cancel": "Cancel",
      "saving": "Saving...",
      "saveEdit": "Save edit",
      "savePlanning": "Save planning",
      "viewActive": "View active",
      "viewArchived": "View archived",
      "edit": "Edit",
      "archive": "Archive",
      "archiving": "Archiving...",
      "restore": "Restore",
      "restoring": "Restoring..."
    },
    "kpis": {
      "visible": "Visible planning records",
      "closed": "Closed",
      "inProgress": "In execution",
      "operationalProgress": "Operational progress",
      "plannedHours": "Planned hours",
      "realHours": "Actual hours",
      "hoursDifference": "Hours diff.",
      "hoursCompliance": "% hours compliance",
      "plannedCost": "Planned cost",
      "realCost": "Actual cost",
      "costDifference": "Cost diff.",
      "currentView": "Current view"
    },
    "summary": {
      "title": "Executive summary by traffic light",
      "subtitle": "Quick reading of operational risk based on the worst deviation between hours and cost.",
      "percentOfTotal": "{{percent}}% of {{total}} planning records"
    },
    "traffic": {
      "green": "In range",
      "yellow": "Moderate deviation",
      "red": "High deviation",
      "none": "No baseline"
    },
    "trafficDescriptions": {
      "green": "Deviation up to 10%.",
      "yellow": "Deviation above 10% and up to 25%.",
      "red": "Deviation above 25%.",
      "none": "There is not enough planned baseline."
    },
    "form": {
      "newTitle": "New operational planning",
      "editTitle": "Edit operational planning",
      "newSubtitle": "Register operational planning to compare later against actual execution.",
      "editSubtitle": "Update the selected organization’s planning record without creating duplicates.",
      "selectGeofence": "Select geofence",
      "selectActivity": "Select activity",
      "startDate": "Start date",
      "endDate": "End date",
      "plannedHours": "Planned hours",
      "plannedCost": "Planned cost",
      "status": "Status",
      "notes": "Notes",
      "notesPlaceholder": "Operational notes",
      "autoCostHint": "Calculated automatically using activity rate and hours{{currency}}.",
      "manualCostHint": "No hourly rate{{currency}}. Enter the cost manually.",
      "editSaveHint": "Saving updates this planning record in the selected organization.",
      "newSaveHint": "Saving creates the planning record in the selected organization and refreshes the list."
    },
    "status": {
      "draft": "Pending",
      "approved": "In progress",
      "closed": "Completed",
      "archived": "Archived"
    },
    "table": {
      "activeTitle": "Active planning records",
      "archivedTitle": "Archived planning records",
      "activeSubtitle": "Active view with budget, actual execution, deviations, traffic light, and totals.",
      "archivedSubtitle": "Archived operating history. Useful for audit and later review.",
      "totalFilteredView": "Total filtered view",
      "filteredView": "Filtered view",
      "columns": {
        "id": "ID",
        "geofence": "Geofence",
        "activity": "Activity",
        "startDate": "Start date",
        "endDate": "End date",
        "plannedHours": "Planned hours",
        "plannedCost": "Planned cost",
        "realHours": "Actual hours",
        "realCost": "Actual cost",
        "hoursDiff": "Hours diff.",
        "costDiff": "Cost diff.",
        "trafficLight": "Traffic light",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "empty": {
      "noFilterResults": "No planning records match the selected filters.",
      "noArchived": "There are no archived planning records for this organization.",
      "noActive": "There is no planning registered for this organization."
    },
    "gantt": {
      "task": "Task",
      "titles": {
        "week": "Weekly operational Gantt",
        "month": "Monthly operational Gantt",
        "quarter": "Quarterly operational Gantt",
        "semester": "Semester operational Gantt",
        "year": "Annual operational Gantt",
        "customDay": "Custom operational Gantt by day",
        "customWeek": "Custom operational Gantt by week",
        "customMonth": "Custom operational Gantt by month"
      },
      "modes": {
        "active": "active planning records",
        "archived": "archived planning records"
      },
      "rangeLabel": " From {{from}} to {{to}}.",
      "subtitles": {
        "day": "Calendar-day view to review {{mode}}.{{rangeLabel}}",
        "week": "Operational-week view to review {{mode}}.{{rangeLabel}}",
        "quarter": "Quarterly view grouped by months to review {{mode}}.{{rangeLabel}}",
        "semester": "Semester view grouped by months to review {{mode}}.{{rangeLabel}}",
        "year": "Annual view grouped by months to review {{mode}}.{{rangeLabel}}",
        "month": "Month-grouped view to review {{mode}}.{{rangeLabel}}"
      }
    },
    "calendar": {
      "weekLabel": "Wk {{number}}",
      "weekdaysShort": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      },
      "monthsShort": {
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dec"
      }
    },
    "modes": {
      "active": "Active",
      "archived": "Archived"
    },
    "csv": {
      "id": "ID",
      "geofence": "Geofence",
      "activity": "Activity",
      "startDate": "Start date",
      "endDate": "End date",
      "plannedHours": "Planned hours",
      "plannedCost": "Planned cost",
      "realHours": "Actual hours",
      "realCost": "Actual cost",
      "hoursDifference": "Hours difference",
      "costDifference": "Cost difference",
      "trafficLight": "Traffic light",
      "trafficDetail": "Traffic light detail",
      "status": "Status",
      "notes": "Notes",
      "mode": "Mode",
      "exportDate": "Export date"
    },
    "validation": {
      "selectGeofence": "Select a geofence.",
      "selectActivity": "Select an activity.",
      "startDate": "Enter a start date.",
      "endDate": "Enter an end date.",
      "invalidDates": "Invalid date format.",
      "endBeforeStart": "The end date cannot be earlier than the start date.",
      "plannedHours": "Enter planned hours.",
      "plannedHoursPositive": "Hours must be a number greater than or equal to 0.",
      "plannedCost": "Enter planned cost.",
      "plannedCostPositive": "Cost must be a number greater than or equal to 0.",
      "invalidStatus": "Invalid status.",
      "reviewFields": "Review the marked fields to continue."
    },
    "alerts": {
      "completeRequired": "Complete the required fields before saving.",
      "noActiveOrg": "There is no active organization to save planning.",
      "saved": "Planning saved successfully.",
      "updated": "Planning updated successfully.",
      "saveError": "Could not save the planning record.",
      "archived": "Planning archived successfully.",
      "archiveError": "Could not archive the planning record.",
      "restored": "Planning restored successfully.",
      "restoreError": "Could not restore the planning record."
    },
    "confirm": {
      "archive": "Archive planning {{id}}? This action will hide it from the active list.",
      "restore": "Restore planning {{id}}? It will return as a draft in the active list."
    },
    "errors": {
      "loadDb": "Could not load planning from Supabase. Showing local demo."
    },
    "fallbacks": {
      "unnamedGeofence": "Unnamed geofence",
      "unnamedActivity": "Unnamed activity",
      "undefinedGeofence": "Undefined geofence",
      "undefinedActivity": "Undefined activity",
      "geofencePrefix": "Geofence",
      "activityPrefix": "Activity"
    },
    "loading": {
      "fromSupabase": "Loading planning from Supabase..."
    },
    "demo": {
      "campusNorth": "North Campus",
      "initialSurvey": "Initial survey",
      "perimeterMarking": "Perimeter marking"
    }
  },
  "personal": {
    "bannerCreated": "Personnel created successfully.",
    "bannerDeletedOk": "Record deleted successfully.",
    "bannerEditMode": "Edit mode.",
    "bannerLoadingSession": "Loading session…",
    "bannerLoginRequired": "You must sign in to access this section.",
    "bannerNewMode": "Creating new personnel.",
    "bannerRefreshedOk": "Data updated successfully.",
    "bannerSelected": "Record selected.",
    "bannerUpdated": "Personnel updated successfully.",
    "buttonDelete": "Delete",
    "buttonEdit": "Edit",
    "buttonFullList": "View all",
    "buttonNew": "New",
    "buttonRefresh": "Refresh",
    "buttonSave": "Save",
    "confirmDelete": "Are you sure you want to delete this record? (soft delete)",
    "errorDelete": "Could not delete the record.",
    "errorDeleteNoRows": "Could not delete: the record does not exist or was already deleted.",
    "errorLoad": "Could not load personnel.",
    "errorMissingEmail": "Email is required.",
    "errorMissingName": "Name is required.",
    "errorMissingUser": "Could not get the authenticated user.",
    "errorMustSelectForDelete": "You must select a record to delete.",
    "errorMustSelectForEdit": "You must select a record to edit.",
    "errorNoAuthUser": "There is no authenticated user.",
    "errorNoPermissionCreate": "You do not have permission to create personnel.",
    "errorNoPermissionDelete": "You do not have permission to delete personnel.",
    "errorNoPermissionEdit": "You do not have permission to edit personnel.",
    "errorNoPermissionSave": "You do not have permission to save changes.",
    "errorPhonePolicy": "Phone must start with + (international E.164 format).",
    "errorSave": "Could not save the personnel record.",
    "errorSaveNoRecord": "No updated record was received.",
    "fieldActive": "Active",
    "fieldEmail": "Email",
    "fieldLastName": "Last name",
    "fieldName": "Name",
    "fieldPhonePlaceholder": "Phone (+593…)",
    "formTitleEdit": "Edit personnel",
    "formTitleNew": "New personnel",
    "no": "No",
    "onlyActive": "Only active",
    "orgFallback": "No organization",
    "orgInfoLabel": "Organization:",
    "pillCanEdit": "Editable",
    "pillReadOnly": "Read only",
    "processing": "Processing...",
    "roleLabel": "Role:",
    "searchPlaceholder": "Search by name, last name, email, or phone...",
    "table": {
      "columns": {
        "active": "Active",
        "email": "Email",
        "end": "End",
        "firstName": "Name",
        "lastName": "Last name",
        "phone": "Phone",
        "start": "Start"
      },
      "loading": "Loading…",
      "noActive": "No active personnel."
    },
    "tableActive": "Active",
    "tableEmail": "Email",
    "tableLastName": "Last name",
    "tableName": "Name",
    "tableNoResults": "No results found.",
    "tablePhone": "Phone",
    "title": "Personnel",
    "noActiveSession": "There is no active session",
    "legacyTable": {
      "actions": "Actions",
      "softDelete": "Delete (soft)",
      "todoEdit": "TODO: Edit"
    },
    "yes": "Yes"
  },
  "reportes": {
    "activityNoName": "Unnamed activity",
    "buttonDownloadCsv": "Download CSV",
    "colActividad": "Activity",
    "colCosto": "Cost",
    "colFin": "End",
    "colGeocerca": "Geofence",
    "colHoras": "Hours",
    "colInicio": "Start",
    "colMoneda": "Currency",
    "colPersona": "Person",
    "colTarifa": "Rate/hour",
    "csvHeaderActividad": "Activity",
    "csvHeaderCosto": "Total_cost",
    "csvHeaderFin": "End",
    "csvHeaderGeocerca": "Geofence",
    "csvHeaderHoras": "Hours",
    "csvHeaderInicio": "Start",
    "csvHeaderMoneda": "Currency",
    "csvHeaderPersona": "Person",
    "csvHeaderTarifa": "Hourly_rate",
    "csvHeaderTotal": "Total_cost",
    "errorCsv": "Could not generate the CSV file.",
    "errorLabel": "Error:",
    "errorLoad": "Error loading reports.",
    "errorLoadFilters": "Error loading filters (people, activities, geofences).",
    "errorLoadReport": "Error loading the cost report.",
    "errorRangeInvalid": "The \"From\" date cannot be later than the \"To\" date.",
    "errorViewMissing": "The view v_costos_detalle has not been created in Supabase yet.",
    "exportNoData": "No data to export.",
    "filters": {
      "activityLabel": "Activity",
      "apply": "Apply filters",
      "clear": "Clear filters",
      "dateFromLabel": "From",
      "dateToLabel": "To",
      "geofenceLabel": "Geofence",
      "personLabel": "Person"
    },
    "filtersActivity": "Activity",
    "filtersAll": "All",
    "filtersApply": "Apply filters",
    "filtersClear": "Clear filters",
    "filtersFrom": "From",
    "filtersGeofence": "Geofence",
    "filtersPerson": "Person",
    "filtersTitle": "Filters",
    "filtersTo": "To",
    "geofenceNoName": "Unnamed geofence",
    "headerSubtitle": "Query and export costs by person, activity and geofence.",
    "loadingReport": "Loading report…",
    "noAccessBody": "You do not have permission to view cost reports. This module is available only for owners and administrators.",
    "personNoName": "Unnamed person",
    "summaryRecordsHelp": "Number of rows matching the current filters.",
    "summaryRecordsLabel": "Records",
    "summaryTotalCostHelp": "Sum of costs calculated by person, activity and geofence.",
    "summaryTotalCostLabel": "Total cost",
    "summaryTotalHoursHelp": "Sum of hours for all assignments in the selected range.",
    "summaryTotalHoursLabel": "Total hours",
    "table": {
      "activity": "Activity",
      "currency": "Currency",
      "end": "End",
      "geofence": "Geofence",
      "hours": "Hours",
      "noResults": "No records found for the selected filters.",
      "person": "Person",
      "rate": "Rate/hour",
      "start": "Start",
      "title": "Cost details",
      "total": "Total cost"
    },
    "tableEmpty": "No records for the selected filters.",
    "tableExportButton": "Export CSV",
    "tableExportHelp": "Export the current details as a CSV file.",
    "tableTitle": "Cost details",
    "title": "Cost reports"
  },
  "resetPassword": {
    "backHome": "Go to landing",
    "backToLogin": "Back to sign in",
    "confirmPassword": "Confirm password",
    "confirmPlaceholder": "Repeat",
    "invalidOrExpired": "The recovery link is invalid or has expired. Request a new one.",
    "loading": "Preparing recovery link…",
    "newPassword": "New password",
    "newPasswordPlaceholder": "At least 8 characters",
    "noSession": "There is no valid session to reset the password. Request a new one.",
    "noticeType": "Session detected. If this link was not for recovery, sign in normally again.",
    "passwordMin": "The password must be at least 8 characters.",
    "passwordMismatch": "Passwords do not match.",
    "saveButton": "Save new password",
    "saving": "Saving…",
    "subtitle": "Create a new password for your account.",
    "success": "Password updated successfully. You can now sign in.",
    "tip": "Tip: go back to /sign-in, enter your email and use \"Forgot your password?\" to generate a new link.",
    "title": "Reset password",
    "unexpected": "An error occurred while preparing the password reset.",
    "updateFailed": "Could not update the password. Please try again.",
    "updateUnexpected": "Unexpected error updating the password."
  },
  "tracker": {
    "page": {
      "title": "GPS Tracker"
    },
    "attendance": {
      "title": "Attendance log",
      "noRecords": "No records",
      "checkIn": "✅ Check in",
      "checkOut": "🚪 Check out",
      "columns": {
        "user": "User",
        "geofence": "Geofence",
        "event": "Event",
        "datetime": "Date and time"
      }
    },
    "panel": {
      "title": "Tracker panel",
      "statusActive": "Active",
      "statusInactive": "No activity",
      "lastUpdateRecent": "Recent last update"
    },
    "gps": {
      "messageStarting": "Starting tracking...",
      "messagePreparing": "Preparing tracking...",
      "messageActive": "Tracking active",
      "titleActive": "Tracking active",
      "browserTitle": "Open GeoField GPS to continue",
      "browserSubtitle": "Your session is ready. This browser cannot start Android tracking.",
      "browserBadge": "Tracking stopped",
      "openPreviewApp": "Open GeoField GPS Preview",
      "browserHelp": "Open the invitation link in the GeoField GPS app installed from Google Play. Tracking can only start in the Android app.",
      "browserHelpPreview": "This test requires the Android version configured for Preview. Open the invitation there. Do not use this session in the production version.",
      "sessionMissingTitle": "Tracking session unavailable",
      "sessionMissingHelp": "Positions are not being sent. Open your current invitation to recover the session. If it was revoked or expired, ask your administrator for a new one.",
      "titleStarting": "Starting tracking",
      "subtitleActive": "Your location is being shared correctly.",
      "subtitleStarting": "We are preparing your session to start tracking.",
      "badgeActive": "Active",
      "badgeInitializing": "Initializing",
      "noteUpdated": "Status updated correctly.",
      "noteWait": "This may take a few seconds."
    },
    "invite": {
      "title": "Location permission",
      "intro": "GeoField GPS collects and uses your precise location with your consent to start an authorized tracking session, share it with the inviting organization, and validate routes, geofences, and reports. Tracking may continue in the background or when the app is not visible. You can stop tracking at any time or revoke location permission in your device settings.",
      "introStep": {
        "before": "Read and accept the location disclosure before continuing.",
        "allow": "GeoField GPS collects, uses, and shares your precise location during the authorized session.",
        "after": " Tracking may continue in the background or when the app is not visible."
      },
      "consentLabel": "I understand and agree that GeoField GPS may collect, use, and share my precise location with the organization that invited me during this authorized tracking session, including when the app is in the background or not visible, to validate routes, geofences, and operational reports.",
      "acceptContinue": "Accept and continue",
      "processing": "Processing...",
      "permissionCardTitle": "Allow location usage",
      "permissionCardBody": {
        "before": "In the next step, the system permission for precise location and background tracking will appear. Tap",
        "after": "to allow it and continue."
      },
      "permissionAction": "Allow location usage",
      "requestingPermission": "Requesting permission...",
      "permissionAutoContinue": "If the browser shows the permission, just confirm and the tracker will continue automatically.",
      "blockedTitle": "We need your location to continue",
      "blockedBody": "Location is blocked or the browser could not show the permission. You must enable it manually to continue.",
      "inAppBrowserHint": {
        "before": "You are inside Gmail or WhatsApp. Use"
      },
      "chromePath": "Chrome → Site settings → Location → Allow",
      "statusLabel": "Status",
      "errors": {
        "missingToken": "Missing invite token.",
        "consentRequired": "You must accept consent before continuing.",
        "blockedSite": "Location is blocked for this site. You must enable it manually to continue.",
        "locationUnavailable": "Could not get location. Enable GPS and try again.",
        "locationTimeout": "Location took too long. Try again with a better GPS signal.",
        "permissionFailed": "Could not get location permission.",
        "blockedChrome": "Location is blocked for this site. In Chrome: Site settings → Location → Allow.",
        "locationUnavailableShort": "Could not get location."
      }
    },
    "history": {
      "traceLabel": "Trace"
    },
    "controls": {
      "centerOnUser": "Center on my position",
      "refresh": "Refresh positions",
      "showAll": "Show all",
      "showInside": "Only inside geofences"
    },
    "errorLoad": "Error loading tracker positions.",
    "legend": {
      "geofence": "Geofence",
      "insideFence": "Inside geofence",
      "outsideFence": "Outside geofence"
    },
    "status": {
      "offline": "No recent data",
      "online": "Tracker online"
    },
    "subtitle": "View tracker locations within your geofences in real time.",
    "table": {
      "activity": "Activity",
      "geofence": "Geofence",
      "noResults": "No positions recorded.",
      "person": "Person",
      "status": "Status",
      "timestamp": "Date/time",
      "title": "Latest positions"
    },
    "title": "GPS Tracker"
  },
  "table": {
    "name": "Name",
    "status": "Status",
    "lastPosition": "Last position",
    "lastUpdate": "Last update"
  },
  "status": {
    "online": "Online",
    "stale": "Outdated",
    "offline": "Offline"
  },
  "map": {
    "coordinates": "Coordenadas",
    "lat": "Lat",
    "lng": "Lng",
    "legend": "Leyenda"
  },
  "trackerDashboard": {
    "title": "Tracking panel",
    "timeWindows": {
      "1h": "1 hour",
      "6h": "6 hours",
      "12h": "12 hours",
      "24h": "24 hours"
    },
    "sections": {
      "filters": "Filters",
      "diagnostics": "Diagnostics",
      "map": "Map"
    },
    "labels": {
      "window": "Window",
      "tracker": "Tracker",
      "geofences": "Geofences",
      "all": "All",
      "activeOrg": "Active org",
      "activeOrgDebug": "Org (Active)",
      "detectedPlan": "Detected plan"
    },
    "actions": {
      "resolveOrgAgain": "Re-resolve org (RPC)",
      "refresh": "Refresh",
      "loading": "Loading…",
      "centerGeofence": "Center geofence"
    },
    "states": {
      "validatingPlan": "Validating organization plan...",
      "planValidationFailed": "Could not validate the organization plan.",
      "moduleUnavailable": "This module is not available on the organization's current plan.",
      "requiresPro": "The tracking dashboard is not enabled for this organization.",
      "upgradeHint": "Check the organization plan status and tracker allowance.",
      "upgradeOrgPrompt": "Manage the organization plan to review access.",
      "resolvingActiveOrg": "Resolving active organization…"
    },
    "messages": {
      "loadAssignmentsError": "Error loading assignments (tracker_assignments).",
      "loadGeofencesError": "Error loading geofences.",
      "loadPositionsError": "Error loading positions.",
      "noActiveAssignments": "No active assignments (tracker_assignments). Showing all active geofences (the default is pre-selected).",
      "noActiveGeofencesForAssignments": "There are assignments, but no active geofences for those assignments in the org ({{orgId}}).",
      "fallbackGeofenceShown": "No active geofences found; 1 active geofence was shown as fallback to avoid an empty panel.",
      "noActiveGeofencesForOrg": "No active geofences available for this org ({{orgId}}).",
      "noVisibleGeofences": "No active/visible geofences available for this org (or you don't have permission to see them).",
      "orgResolveError": "Error resolving org"
    },
    "badges": {
      "assignments": "assignments",
      "trackers": "trackers",
      "geofences": "geofences",
      "polys": "polys",
      "circles": "circles",
      "positions": "positions",
      "source": "src",
      "assignedIds": "assignedIds",
      "selected": "selected",
      "bounds": "bounds",
      "viewport": "viewport",
      "intersects": "intersects"
    },
    "map": {
      "initializing": "Initializing map…",
      "statusPrefix": "map",
      "circleLabel": "{{name}} (circle)"
    },
    "tooltip": {
      "tracker": "Tracker",
      "time": "Time",
      "lat": "Lat",
      "lng": "Lng",
      "accuracy": "Acc",
      "speed": "Speed",
      "source": "Src"
    },
    "multiGeofence": {
      "labelBase": "Geofences",
      "labelNone": "Geofences: None",
      "labelAll": "Geofences: All ({{count}})",
      "labelSelected": "Geofences: {{count}}",
      "searchPlaceholder": "Search geofence…",
      "showAll": "Show all",
      "hideAll": "Hide all",
      "noResults": "No results…",
      "close": "Close"
    }
  },
  "trackerGps": {
    "title": "GPS Tracker",
    "lastSend": "Last send",
    "waitingCoords": "Waiting for coordinates…",
    "debugCopyPaste": "Debug (copy/paste)",
    "stateLabel": "Status",
    "onlyInvited": "This page is for invited trackers only.",
    "goHome": "Go to home",
    "status": {
      "initializing": "Initializing tracker…",
      "processingMagicLink": "Processing Tracker Magic Link…",
      "sessionOkPreparing": "Session OK. Preparing tracker…",
      "readingSession": "Reading tracker session…",
      "noSession": "There is no active tracker session.",
      "noGeolocation": "This device does not support geolocation.",
      "active": "Tracker active",
      "activating": "Activating tracker in the organization…",
      "noPermission": "Tracker without permission / onboarding",
      "gpsError": "GPS error"
    },
    "errors": {
      "notConfigured": "The tracker is not configured in this deployment.",
      "noSupabaseClient": "The main Supabase client was not found.",
      "setSession": "Error in setSession:",
      "hashSession": "Hash session error:",
      "openFromMagicLinkOnly": "Open this page only from your Tracker Magic Link.",
      "geolocationUnavailable": "Geolocation not available."
    },
    "membership": {
      "missingOrgId": "org_id is missing from the URL. Open this page from the invitation link: /tracker-gps?org_id=<ORG_ID>.",
      "checking": "Verifying membership…",
      "noValidTokenUser": "No valid token/user in /tracker-gps.",
      "okSessionCache": "Membership OK (session cache).",
      "membershipsSelectError": "Error in memberships select:",
      "alreadyExists": "Membership already exists: role={{role}}",
      "runningAccept": "No membership found. Running accept-tracker-invite",
      "acceptError": "Error from accept-tracker-invite:",
      "membershipsRecheckError": "Error rechecking memberships:",
      "acceptReturnedButNotCreated": "accept-tracker-invite returned OK but the membership was not created.",
      "acceptOk": "accept-tracker-invite OK.",
      "onboardingException": "Exception during onboarding:"
    },
    "disclosure": {
      "title": "Background location",
      "body1": "GeoField GPS collects your location even when the app is closed or the phone is locked, to record positions and validate entry and exit from geofences during your work shift.",
      "body2": "This information is used solely for operational purposes of the organization and is not shared with third parties or used for advertising. You can stop tracking by revoking the location permission or signing out.",
      "continue": "Continue"
    },
    "debugLabels": {
      "send": "send",
      "accept": "accept",
      "orgId": "org_id",
      "membership": "membership",
      "tokenIss": "token_iss",
      "tokenTtlSec": "token_ttl_sec",
      "lastHttpStatus": "last_http_status",
      "lat": "lat",
      "lng": "lng",
      "acc": "acc"
    },
    "perms": {
      "panelTitle": "Critical tracker permissions",
      "panelDesc": "To keep GeoField GPS working after restarting the phone or leaving it idle, enable these critical permissions.",
      "locationAlways": "Always allow location",
      "locationAlwaysAlert": "Enable ALWAYS location: Settings > Apps > GeoField GPS > Permissions > Location > Allow all the time.",
      "batteryUnrestricted": "Unrestricted battery",
      "batteryUnrestrictedAlert": "Disable battery restrictions: Settings > Apps > GeoField GPS > Battery > Unrestricted or Do not optimize.",
      "autostart": "Auto-start",
      "autostartAlert": "Enable auto-start: Settings / Phone Master / Power Center > Auto-start management > GeoField GPS > Allow.",
      "backgroundData": "Background data",
      "backgroundDataAlert": "Allow background activity and data: Settings > Apps > GeoField GPS > Mobile data / Battery > Allow background usage."
    }
  },
  "pricing": {
    "accessDenied": "You do not have permission to view monetization for this organization.",
    "common": {
      "currentPlan": "Current plan",
      "loading": "Loading...",
      "notAvailable": "—",
      "unlimited": "Unlimited"
    },
    "actions": {
      "goToBilling": "Go to Billing",
      "contactSales": "Contact sales"
    },
    "page": {
      "title": "Plans and pricing",
      "previewNotice": {
        "prefix": "This screen runs in",
        "previewTag": "PREVIEW",
        "middle": "and uses the subscription flow in",
        "testTag": "TEST",
        "suffix": ""
      }
    },
    "summary": {
      "detectedPlan": "Detected plan",
      "noCommercialData": "No commercial data",
      "status": "Status",
      "trialUntil": "Trial until",
      "planCodes": {
        "free": "FREE",
        "pro": "PRO",
        "enterprise": "ENTERPRISE"
      },
      "planCodeUnknown": "{{code}}",
      "maxGeofences": "Max geofences",
      "maxTrackers": "Max trackers"
    },
    "free": {
      "title": "Free",
      "subtitle": "To get started",
      "price": "$0",
      "description": "Designed to validate initial platform usage.",
      "currentPlanMessage": "You are already on the Free plan.",
      "features": {
        "validateFlow": "Ideal to start and validate the base flow",
        "upToTrackers": "Up to {{count}} tracker",
        "geofenceLimits": "Geofences with plan-based limits",
        "billingAndUpgrade": "Access Billing and the future plan upgrade path",
        "backendEnforcement": "Backend continues applying real enforcement"
      }
    },
    "pro": {
      "title": "Pro",
      "subtitle": "Active SaaS operations",
      "price": "Pro",
      "description": "Recommended plan to enable the Tracker module and operate with subscriptions.",
      "higherPlanMessage": "Your organization already has a higher plan or a plan different from Free.",
      "reviewBillingMessage": "Review Billing to manage it.",
      "features": {
        "upToTrackers": "Up to {{count}} trackers per organization",
        "upToGeofences": "Up to {{count}} geofences",
        "trackerEnabled": "Tracker module enabled",
        "invitesEnabled": "Tracker invitations enabled",
        "stripeSelfManaged": "Self-managed subscription"
      }
    },
    "enterprise": {
      "title": "Enterprise",
      "subtitle": "Assisted sales",
      "price": "Custom",
      "description": "For organizations that require special commercial conditions.",
      "features": {
        "salesOnboarding": "Sales assistance and guided onboarding",
        "flexibleLimits": "Adjustable limits and conditions",
        "multiTeamReady": "Ready for multi-team operations",
        "specialAgreements": "Commercial scaling and special agreements",
        "directSalesContact": "Direct sales contact"
      }
    },
    "notes": {
      "title": "Notes for this phase",
      "backendAuthority": "The backend remains the real authority for the plan. This page only reflects the plan and shows available commercial actions.",
      "proCheckout": "Upgrading to Pro uses a secure checkout. Manage your subscription from Billing.",
      "enterpriseSales": "Enterprise is presented as a commercial channel, without enabling automatic checkout."
    },
    "status": {
      "active": "Active",
      "trialing": "Trial",
      "past_due": "Past due",
      "canceled": "Canceled",
      "paused": "Paused",
      "incomplete": "Incomplete",
      "other": "Status: {{status}}"
    }
  },
  "billing": {
    "errors": {
      "loadPlanStatus": "Could not load plan status."
    },
    "cancel": {
      "title": "Checkout cancelled",
      "subtitle": "No charge was made.",
      "backToBilling": "Back to Billing",
      "goHome": "Go to Home"
    },
    "title": "Billing",
    "authRequired": "Sign in to manage your plan.",
    "previewNotice": {
      "prefix": "Monetization in",
      "middle": "(Subscription flow).",
      "suffix": ""
    },
    "actions": {
      "viewPlans": "View plans"
    },
    "labels": {
      "email": "Email",
      "orgId": "Organization ID"
    },
    "planState": {
      "title": "Plan status"
    },
    "states": {
      "loadingPlanStatus": "Loading plan status..."
    },
    "cards": {
      "currentPlan": "Current plan",
      "status": "Status",
      "trialUntil": "Trial until",
      "currentPeriodUntil": "Current period until"
    },
    "subscriptionManagement": {
      "title": "Subscription management",
      "description": "Open Billing to manage your subscription details.",
      "cancelRenewal": "Cancel renewal",
      "confirmCancelRenewal": "This will cancel automatic renewal. Your plan will remain active until the end of the current billing period. Do you want to continue?",
      "cancelingRenewal": "Canceling renewal...",
      "renewalCanceled": "Renewal canceled. Your plan will remain active until the end of the current billing period.",
      "cancelRenewalError": "Could not cancel the renewal."
    },
    "messages": {
      "cancelAtPeriodEnd": "Your subscription is set to cancel at the end of the current period.",
      "activePlanExists": "An active plan already exists for this organization. The upgrade button is not shown."
    },
    "upgrade": {
      "productTitle": "Geocercas PRO",
      "orgIdLabel": "Org ID",
      "notResolved": "(not resolved)",
      "organizationInputLabel": "Organization ID (org_id)",
      "organizationInputPlaceholder": "E.g. ea4f7ebc-651a-48b9-9ac3-b0bdbee1db9a",
      "organizationInputHelp": "If it is not detected automatically, paste the organization UUID here.",
      "subscribe": "Subscribe to PRO",
      "processing": "Processing...",
      "noticeTitle": "Notice",
      "messages": {
        "paddleError": "PAYMENT PROVIDER ERROR:\n{{details}}",
        "checkoutUrlMissing": "CHECKOUT URL MISSING:\n{{details}}",
        "paddleException": "PAYMENT PROVIDER EXCEPTION:\n{{details}}"
      },
      "errors": {
        "invalidOrgId": "Invalid Org ID. Copy the Organization ID (UUID) and paste it here."
      }
    },
    "compareBeforeUpgrade": {
      "title": "Want to compare before upgrading?",
      "description": "Review the plans page to compare Free, Pro and Enterprise."
    },
    "status": {
      "trialing": "Trial",
      "active": "Active",
      "pastDue": "Past due",
      "canceled": "Canceled",
      "free": "Free"
    }
  },
  "reports": {
    "title": "Reports",
    "currentOrg": "Current org",
    "sessionLoading": "Loading your session…",
    "noActiveSession": "No active session. Sign in again.",
    "noActiveOrg": "No active organization for this user.",
    "filters": {
      "title": "Filters",
      "subtitle": "Select ranges and lists. Then press Generate.",
      "reloadLists": "Reload lists",
      "reloadFilters": "Reload filters",
      "clearSelections": "Clear selections",
      "clearSelectionsTitle": "Clear selections (does not clear dates)",
      "from": "From",
      "to": "To",
      "generate": "Generate",
      "generating": "Generating…",
      "exportCsv": "Export CSV",
      "tipLabel": "Tip:",
      "tipMultiSelect": "In multi-select lists use Ctrl (Windows) / Command (Mac) to select multiple.",
      "geofences": "Geofences",
      "people": "People",
      "activities": "Activities",
      "assignments": "Assignments",
      "multi": "(multi)",
      "assignmentFallback": "assignment",
      "assignmentNote": "Note: if your assignments do not have personal_id, the join with check-ins may be empty."
    },
    "results": {
      "title": "Results",
      "generating": "Generating report…",
      "rows": "Rows: {{count}}",
      "emptyHint": "No data yet. Adjust filters and generate.",
      "loading": "Loading…",
      "noDataSelectedFilters": "No data for the selected filters."
    },
    "table": {
      "day": "Day",
      "person": "Person",
      "email": "Email",
      "geofence": "Geofence",
      "activity": "Activity",
      "assignment": "Assignment",
      "entry": "Entry",
      "exit": "Exit",
      "marks": "Check-ins",
      "inside": "Inside",
      "distanceM": "Dist (m)",
      "rate": "Rate",
      "dash": "—"
    },
    "errors": {
      "loadFilters": "Error loading filters.",
      "noActiveOrgOrSession": "No active organization or session is not ready.",
      "invalidDateRange": "The \"From\" date cannot be later than the \"To\" date.",
      "generateReport": "Error generating report.",
      "exportNoData": "No data to export."
    }
  },
  "activityAssignments": {
    "title": "Activity assignments",
    "subtitle": "Define which activity each person performs in a date range. The same person cannot have two activities at the same time.",
    "session": "Session",
    "actions": {
      "new": "+ New assignment",
      "refresh": "Refresh",
      "edit": "Edit",
      "delete": "Delete",
      "clear": "Clear",
      "newShort": "New",
      "saveChanges": "Save changes",
      "createAssignment": "Create assignment",
      "saving": "Saving..."
    },
    "filters": {
      "trackerPerson": "Tracker / Person",
      "activity": "Activity",
      "startFrom": "Start from",
      "endUntil": "End until",
      "allTrackers": "All",
      "allActivities": "All"
    },
    "table": {
      "title": "Assignment list",
      "loading": "Loading...",
      "person": "Person",
      "activity": "Activity",
      "start": "Start",
      "end": "End",
      "actions": "Actions",
      "empty": "No assignments for the current filters."
    },
    "form": {
      "titleCreate": "New assignment",
      "titleEdit": "Edit assignment",
      "titleView": "Details / new assignment",
      "trackerPerson": "Person / Tracker",
      "activity": "Activity",
      "startDate": "Start date",
      "endDateOptional": "End date (optional)",
      "selectOption": "Select..."
    },
    "messages": {
      "initialLoadError": "Error loading initial data",
      "activitiesLoadError": "Could not load activities",
      "trackersLoadError": "Could not load trackers",
      "assignmentsLoadError": "Could not load assignments",
      "requiredFields": "Tracker, activity and start date are required",
      "assignedSuccessfully": "Activity assigned successfully",
      "updatedSuccessfully": "Assignment updated successfully",
      "invalidFormMode": "Invalid form mode",
      "constraintOverlap": "Cannot assign this activity: the person already has another activity in that date range.",
      "saveError": "Error saving the activity assignment",
      "deletedSuccessfully": "Assignment deleted successfully",
      "deleteError": "Could not delete the activity assignment"
    },
    "overlap": {
      "selectedPerson": "selected",
      "otherActivity": "another activity",
      "noEndDate": "no end date",
      "message": "The person {{person}} already has the activity \"{{activity}}\" assigned between {{start}} and {{end}}."
    },
    "confirmDelete": "Are you sure you want to delete the assignment of \"{{activity}}\" for \"{{tracker}}\"?",
    "fallbacks": {
      "activity": "activity",
      "tracker": "tracker"
    }
  },
  "admin": {
    "dashboard": {
      "title": "Administration Panel",
      "configRequired": "Configuration required",
      "modules": {
        "geocercas": "Geofences",
        "geocercasV2": "Geofences V2",
        "personal": "Personnel",
        "reports": "Reports"
      },
      "modulesDescriptions": {
        "geocercas": "Manage your organization's geofences",
        "geocercasV2": "Enhanced geofences with new interface",
        "personal": "Manage field personnel",
        "reports": "View reports and events"
      },
      "logout": "Sign out"
    },
    "geocercasV2": {
      "title": "Geofences",
      "showAll": "Show all",
      "back": "← Back",
      "savedGeofencesHeader": "Saved geofences",
      "loading": "Loading...",
      "noGeofences": "No geofences",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "actions": {
        "view": "View",
        "deactivate": "Deactivate",
        "activate": "Activate",
        "edit": "Edit",
        "editInMap": "Edit on map",
        "delete": "Delete"
      },
      "floatingActions": {
        "save": "Save",
        "cancel": "Cancel"
      },
      "prompt": {
        "name": "Geofence name:",
        "newName": "New name (leave the same if you don't want to change):",
        "editCoords": "Edit coordinates (lat,lng per line). Leave blank to keep:"
      },
      "manualForm": {
        "title": "Create geofence manually",
        "hintFormat": "Format: lat,lng per line. Minimum 3 lines.",
        "saveButton": "Save manual"
      },
      "labels": {
        "personal": "Personnel:",
        "assignments": "Assignments:"
      },
      "mapControls": {
        "latLngTip": "Move cursor to see Lat/Lng"
      }
    },
    "usersRoles": {
      "title": "Users and Roles",
      "processing": "Processing…",
      "inviteSection": "Invite user",
      "emailPlaceholder": "email@domain.com",
      "fullNamePlaceholder": "Full name",
      "fullNameLabel": "Full name",
      "roleOwner": "OWNER",
      "inviteButton": "Invite",
      "pendingInvitesTitle": "Pending invitations",
      "noPending": "No invitations.",
      "usersTitle": "Users",
      "noUsers": "No registered users.",
      "table": {
        "email": "Email",
        "name": "Name",
        "role": "Role",
        "date": "Date",
        "actions": "Actions",
        "newRole": "New Role"
      },
      "magicLink": "Magic Link",
      "deleteButton": "Delete",
      "assignButton": "Assign",
      "confirmDelete": "Delete/suspend {{correo}}?",
      "inviteSuccess": "Invitation sent to {{correo}}",
      "assignSuccess": "Role \"{{role}}\" assigned to {{correo}}",
      "magicLinkSentInvite": "Invitation sent to {{correo}}",
      "magicLinkSentLink": "Magic link sent to {{correo}}",
      "deleteSuccess": "User {{correo}} deleted/suspended"
    },
    "geofences": {
      "errors": {
        "loadFailed": "Could not load the list",
        "invalidPolygon": "Draw a valid polygon.",
        "saveFailed": "Error saving",
        "invalidInput": "Check name and at least 3 valid coordinates.",
        "createFailed": "Could not save the geofence",
        "statusChangeFailed": "Could not change status",
        "deleteFailed": "Could not delete",
        "noCoordinates": "Geofence with no valid coordinates",
        "minimumPoints": "At least 3 valid points are required.",
        "editFailed": "Could not edit",
        "invalidCoordinates": "Invalid coordinates.",
        "invalidPolygonData": "Invalid polygon."
      },
      "messages": {
        "created": "✅ Geofence saved.",
        "createdManual": "Geofence created (manual).",
        "activated": "✅ Activated",
        "deactivated": "✅ Deactivated",
        "deleted": "🗑️ Deleted.",
        "updated": "✏️ Geofence updated.",
        "mapEditActive": "🟠 Map edit active. Adjust vertices and click 'Save changes'.",
        "editCancelled": "Edit cancelled.",
        "changesSaved": "✅ Changes saved."
      },
      "confirmDelete": "Delete \"{{name}}\"?"
    }
  },
  "trackerPanel": {
    "title": "Tracker Panel",
    "description": "Here you will see your assigned geofences, your status (inside/outside) and you can report incidents.",
    "logout": "Sign out"
  },
  "mapaTracking": {
    "traceLabel": "Trace:",
    "timeWindows": {
      "15min": "15 min",
      "30min": "30 min",
      "60min": "60 min"
    },
    "refresh": "Refresh",
    "loading": "Loading…"
  },
  "newOrg": {
    "title": "New organization",
    "labels": {
      "name": "Name",
      "slug": "Slug (optional)"
    },
    "placeholders": {
      "name": "E.g. Main Farm",
      "slug": "e.g. main-farm"
    },
    "buttons": {
      "create": "Create",
      "cancel": "Cancel"
    }
  },
  "geofenceForm": {
    "title": "New geofence",
    "fields": {
      "name": "Name",
      "coordinates": "Coordinates",
      "onePerLine": "per line"
    },
    "placeholders": {
      "name": "E.g. Field 1",
      "example": "-0.1807, -78.4678"
    },
    "labels": {
      "name": "Name",
      "coordinates": "Coordinates (lat,lng per line)"
    },
    "actions": {
      "save": "Save geofence",
      "saving": "Saving..."
    },
    "hints": {
      "mapSelection": "Draw or select on the map; if the box is empty, that polygon will be used."
    },
    "map": {
      "lat": "Lat",
      "lng": "Lng",
      "movePointer": "Move the pointer over the map…"
    },
    "errors": {
      "minPoints": "At least 3 points are required."
    },
    "fallbacks": {
      "unnamed": "Unnamed"
    },
    "messages": {
      "saved": "Geofence saved successfully.",
      "errorPrefix": "Error",
      "created": "Geofence created successfully.",
      "createError": "Error creating geofence",
      "updated": "Geofence(s) updated successfully.",
      "updateError": "Error updating geofence",
      "deleted": "Geofence(s) deleted successfully.",
      "deleteError": "Error deleting geofence"
    }
  },
  "geofences": {
    "labels": {
      "personal": "Personnel:",
      "assignments": "Assignments:"
    },
    "actions": {
      "links": "Links"
    }
  },
  "currencies": {
    "USD": "US dollar",
    "CAD": "Canadian dollar",
    "BRL": "Brazilian real"
  },
  "benchmarking": {
    "header": {
      "badge": "Continuous improvement",
      "title": "Benchmarking",
      "subtitle": "Compare operational efficiency across assignments, geofences, people, or activities using hours/m² and $/m²."
    },
    "actions": {
      "refresh": "Refresh",
      "exportCsv": "Export CSV",
      "resetFilters": "Clear filters"
    },
    "alerts": {
      "plannedOnlyTitle": "Planned data.",
      "plannedOnlyBody": "The current view has no tracking hours linked to assignments. Benchmarking uses planned hours and labels the source as PLANNED."
    },
    "filters": {
      "all": "All",
      "geofence": "Geofence",
      "person": "Person / worker",
      "activity": "Activity",
      "dateFrom": "From",
      "dateTo": "To",
      "period": "Grouped period",
      "compareBy": "Compare by",
      "indicator": "Indicator",
      "chartType": "Chart type",
      "title": "Filters",
      "subtitle": "Adjust the view to compare operational efficiency."
    },
    "periods": {
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "quarter": "Quarter",
      "semester": "Semester",
      "year": "Year"
    },
    "compareBy": {
      "assignment": "Assignments",
      "geofence": "Geofences",
      "person": "People",
      "activity": "Activities"
    },
    "indicators": {
      "horas_m2": "Hours/m²",
      "costo_m2": "$/m²"
    },
    "chartTypes": {
      "bars": "Bars",
      "lines": "Lines"
    },
    "kpis": {
      "best": "Best efficiency",
      "worst": "Worst efficiency",
      "average": "Overall average",
      "totalDifference": "Total accumulated difference",
      "totalDifferenceHint": "Sum of differences vs average",
      "optimizableCost": "Potentially optimizable cost",
      "optimizableCostHint": "Excess vs average",
      "optimizableHours": "Potentially optimizable hours",
      "optimizableHoursHint": "Excess vs average"
    },
    "chart": {
      "title": "Visualization",
      "subtitle": "Bars compare groups; lines show average time evolution."
    },
    "table": {
      "title": "Comparative table",
      "subtitle": "Alerts show deviation from the visible average; they do not make automatic decisions.",
      "rows": "{{count}} rows",
      "signal": "Signal",
      "geofence": "Geofence",
      "person": "Person",
      "activity": "Activity",
      "period": "Period",
      "areaM2": "Area m²",
      "areaReadable": "Readable area",
      "observedHours": "Observed hours",
      "plannedHours": "Planned hours",
      "costBase": "Base cost",
      "costFinal": "Audited final cost",
      "hoursM2": "Hours/m²",
      "costM2": "$/m²",
      "diffAverage": "Difference vs average",
      "cumulativeDiff": "Accumulated difference",
      "evidence": "Source",
      "opportunity": "Improvement opportunity"
    },
    "traffic": {
      "green": "Green",
      "yellow": "Yellow",
      "red": "Red",
      "gray": "No data"
    },
    "opportunities": {
      "green": "Maintain standard and use as reference",
      "yellow": "Review moderate deviation",
      "red": "Prioritize operational analysis",
      "gray": "Complete data before comparing"
    },
    "evidence": {
      "TRACKING": "Tracking",
      "PLANIFICADA": "Planned",
      "MIXTA": "Mixed"
    },
    "fallbacks": {
      "geofence": "Unnamed geofence",
      "person": "Unnamed person",
      "activity": "Unnamed activity"
    },
    "labels": {
      "multiple": "Multiple"
    },
    "empty": {
      "chart": "Not enough data to chart.",
      "table": "No benchmarking data with the current filters."
    },
    "errors": {
      "load": "Could not load benchmarking."
    },
    "loading": "Loading benchmarking...",
    "csv": {
      "title": "Operational benchmarking",
      "exportedAt": "Export date"
    }
  },
  "plans100": {
    "catalogLimits": "Up to {{trackers}} trackers and {{geofences}} geofences",
    "subscribe": "Subscribe to ENTERPRISE 100",
    "upgrade": "Upgrade to ENTERPRISE 100",
    "maximum": "Your organization already has the highest plan (ENTERPRISE 100).",
    "description": "For operations with up to 100 trackers.",
    "limits": "Up to 100 trackers and 250 geofences",
    "confirmTitle": "Confirm change to {{plan}}",
    "confirmBody": "Your existing subscription will change to {{plan}}. The provider will apply proration using your existing payment method. No second subscription will be created.",
    "alreadyActive": "Your organization already has this plan or a higher plan."
  }
}
